const et = {
  // Navigation
  nav: {
    features: 'Funktsioonid',
    useCases: 'Kasutusjuhud',
    pricing: 'Hinnakiri',
    blog: 'Blogi',
    about: 'Meist',
    consulting: 'Konsultatsioon',
    login: 'Logi sisse',
    startFree: 'Loo konto →',
    dashboard: 'Töölaud',
    teams: 'Meeskonnad',
    tasks: 'Ülesanded',
    kpis: 'KPI-d',
    users: 'Kasutajad',
    profileSettings: 'Profiili seaded',
    companySettings: 'Ettevõtte seaded',
    subscription: 'Tellimus',
    superAdminPanel: 'SuperAdmin paneel',
    logout: 'Logi välja',
  },

  // Use cases dropdown
  useCases: {
    smallStartups: 'Väikeettevõtted (1-20)',
    smb: 'Keskmised ettevõtted (21-200)',
    enterprise: 'Suurettevõtted',
    itTeams: 'IT meeskonnad',
    ecommerce: 'E-kaubandus',
    saas: 'SaaS ettevõtted',
    sales: 'Müük',
    operations: 'Operatiivtöö',
    managementBoard: 'Juhtkond',
    publicInstitutions: 'Avalik sektor',
    nonprofits: 'MTÜ-d',
    consulting: 'Konsultatsioon ja agentuurid',
    manufacturing: 'Tootmine',
  },

  // Feature pages dropdown
  featurePages: {
    executionManagement: 'Elluviimise juhtimise platvorm',
    kpiManagement: 'KPI juhtimine',
    taskManagement: 'Ülesannete haldus',
    projectManagement: 'Projektijuhtimine',
  },

  // Landing page
  landing: {
    badge: 'Outsprinter on tasuta projektijuhtimise tarkvara',
    heroTitle1: 'Eesmärgid, tulemused, projektid ja taskid ühes kohas koos',
    heroTitle2: 'outsprinter.com',
    heroDescription: 'Saavuta täielik ülevaade ja hoia kogu meeskonna fookus kõige olulisemal, alati!',
    getStarted: 'Loo konto',
    viewDemo: 'Vaata demo',
    featuresTitle: 'Kõik, mida vajad tulemuslikkuse jälgimiseks',
    featuresSubtitle: 'Loodud kaasaegsetele ettevõtetele, kes soovivad jälgida ja juhtida ettevõtte tulemusi läbipaistvalt',
    fromBlog: 'Meie blogist',
    blogTitle: 'Ekspertide nõuanded KPI\'de juhtimiseks',
    blogSubtitle: 'Tõestatud strateegiausate KPI süsteemide loomiseks ja tulemuslikkuse tõstmiseks.',
    readArticle: 'Loe artiklit',
    viewAllArticles: 'Vaata kõiki artikleid',
    ctaTitle: 'Valmis oma tulemuslikkust selgelt juhtima?',
    ctaSubtitle: 'Alusta kohe! Kasuta Outsprinterit, et püsida rajal ja kasvatada oma äri',
    startTrial: 'Loo konto',
  },

  // Features
  features: {
    dashboard: 'Töölaud',
    dashboardDesc: 'Reaalajas graafikud ja tulemuslikkuse ülevaade, mis uueneb koheselt andmete sisestamisel.',
    taskManagement: 'Ülesannete haldus',
    taskManagementDesc: 'Loo, määra ja jälgi ülesandeid prioriteetide, tähtaegade, alamülesannete ja korduvate reeglitega.',
    projectManagement: 'Projektide haldus',
    projectManagementDesc: 'Korralda tööd projektidesse koos tervise mõõdikute, töökoormuse analüüsi ja edenemise jälgimisega.',
    kpiManagement: 'KPI haldus',
    kpiManagementDesc: 'Defineeri, jälgi ja visualiseeri peamisi tulemusnäitajaid kogu organisatsioonis.',
    goalPlanner: 'Eesmärkide planeerija',
    goalPlannerDesc: 'Sea aastased eesmärgid, jaga need nädala verstapostideks ja jälgi strateegiliste eesmärkide saavutamist.',
    userManagement: 'Kasutajate haldus',
    userManagementDesc: 'Halda meeskondi org struktuuriga, rollipõhise ligipääsu ja osakonna taseme õigustega.',
    aiAssistant: 'AI assistent',
    aiAssistantDesc: 'Vestle, et planeerida paremaid KPI-sid, analüüsida tulemuslikkust ja saada praktilisi soovitusi.',
    notifications: 'Teavitused',
    notificationsDesc: 'Püsi kursis reaalajas teavitustega ülesannete uuenduste, KPI muudatuste ja meeskonna tegevuse kohta.',
    dataImportExport: 'Andmete import / eksport',
    dataImportExportDesc: 'Impordi KPI andmeid Excelist ja ekspordi aruandeid CSV formaadis väliseks analüüsiks.',
  },

  // Footer
  footer: {
    description: 'Kaasaegne viis juhtidele ja meeskondadele KPI-de jälgimiseks, riskide varajaseks tuvastamiseks ja kõigi ühele lehele saamiseks.',
    product: 'Toode',
    useCases: 'Kasutusjuhud',
    resources: 'Ressursid',
    company: 'Ettevõte',
    legal: 'Juriidiline',
    features: 'Funktsioonid',
    pricing: 'Hinnakiri',
    updates: 'Uuendused',
    blog: 'Blogi',
    helpCenter: 'Abi ja tugi',
    faq: 'KKK',
    aboutUs: 'Meist',
    consultingAdvisory: 'Konsultatsioon ja nõustamine',
    contact: 'Kontakt',
    press: 'Press',
    affiliates: 'Partnerid (affiliate)',
    termsOfService: 'Teenuse tingimused',
    privacyNotice: 'Privaatsus',
    cookiePolicy: 'Küpsiste poliitika',
    copyright: '© 2026 Outsprinter. Kõik õigused kaitstud.',
    uptime: '99.9% tööaeg',
  },

  // Pricing page
  pricing: {
    tryFree: 'Kasuta tasuta',
    manageSubscription: 'Halda oma tellimust',
    chooseYourPlan: 'Vali oma plaan',
    yourSubscription: 'Sinu tellimus',
    subscribedSubtitle: 'Sul on aktiivne tellimus. Uuenda või halda oma plaani allpool.',
    unsubscribedSubtitle: 'Kõik plaanid sisaldavad Outsprinteri täisfunktsionaalsust. Vali vastavalt meeskonna suurusele.',
    monthly: 'Kuumakse',
    yearly: 'Aastamakse',
    save30: 'Säästa 30% võrreldes kuumaksega',
    month: 'kuu',
    year: 'aasta',
    planLimits: 'Plaani piirangud',
    allFeaturesIncluded: 'Kõik funktsioonid kaasas',
    bestFor: '🎯 Sobib:',
    startFree: 'Loo konto',
    currentPlan: 'Praegune plaan',
    switchPlan: 'Vaheta plaani',
    subscribeNow: 'Telli kohe',
    processing: 'Töötlemisel...',
    yourPlan: 'Sinu plaan',
    popular: 'Populaarne',
    enterpriseLine: 'Vajad rohkem kui 75 kasutajat, SSO-d või API ligipääsu?',
    contactUs: 'Võta ühendust',
    forEnterprise: 'ettevõtte hinnapakkumise saamiseks.',
    needHelp: 'Vajad abi? Võta ühendust meie tugitiimiga.',
    allPlansInclude: 'Outsprinter on kõigile tasuta. Krediitkaarti pole vaja.',
    redirecting: 'Suunamine makselehele',
    redirectingDesc: 'Sind suunatakse tellimuse lõpetamiseks.',
    checkoutError: 'Makse alustamine ebaõnnestus. Palun proovi uuesti.',
    starter: 'STARTER',
    starterDesc: 'Väikestele meeskondadele alustamiseks',
    professional: 'PROFESSIONAL',
    professionalDesc: 'Kasvavatele ettevõtetele',
    business: 'BUSINESS',
    businessDesc: 'Suuremate organisatsioonide jaoks',
    teams3: '3 meeskonda',
    kpis20: '20 KPI-d',
    users5: '5 kasutajat',
    teams10: '10 meeskonda',
    kpis75: '75 KPI-d',
    users25: '25 kasutajat',
    teamsUnlimited: 'Piiramatu arv meeskondi',
    kpisUnlimited: 'Piiramatu arv KPI-sid',
    users75: '75 kasutajat',
    smallBusinesses: 'Väikeettevõtted',
    agencies: 'Agentuurid',
    employees520: '5–20 töötajat',
    scalingStartups: 'Kasvavad idufirmad',
    employees20100: '20–100 töötajat',
    multiDepartment: 'Mitme osakonnaga',
    employees100: '100+ töötajat',
    leadershipTeams: 'Juhtkonnad',
    investorReporting: 'Nõukogule aruandlus',
    dashboard: 'Töölaud',
    taskManagement: 'Ülesannete haldus',
    projectManagement: 'Projektide haldus',
    kpiManagement: 'KPI haldus',
    goalPlanner: 'Eesmärkide planeerija',
    userManagementOrg: 'Kasutajate haldus koos org struktuuriga',
    aiAssistant: 'AI assistent',
    notifications: 'Teavitused',
    dataImportExport: 'Andmete import / eksport',
  },

  // About page
  about: {
    title: 'Outsprinterist',
    heroDescription: 'Outsprinter on tulemuslikkuse juhtimise platvorm, mis on loodud juhtidele, kes soovivad',
    realClarity: 'tõelist selgust',
    realAccountability: 'tõelist vastutust',
    realResults: 'tõelisi tulemusi',
    missionIntro: 'Lõime Outsprinteri, et lahendada probleem, mis esineb peaaegu igas ettevõttes: eesmärgid on seatud, kuid edenemine on ebaselge, killustatud ja sageli põhineb kõhutundel, mitte tegelikel andmetel.',
    missionTitle: 'Meie missioon on lihtne —',
    missionDesc: 'aidata ettevõtetel hallata oma tulemuslikkust läbipaistval, andmepõhisel ja järjepideval viisil, nii et iga meeskond teab:',
    missionPoint1: 'mis on oluline,',
    missionPoint2: 'kuidas neil läheb,',
    missionPoint3: 'ja mis vajab kohe tähelepanu.',
    executionRhythm: 'Outsprinter muudab strateegia iganädalaseks täitmisrütmiks.',
    replacesExcel: 'See asendab laiali paisatud Exceli failid, unustatud KPI-d ja hägustunud vastutuse:',
    kpiTree: 'visuaalse KPI puuga,',
    weeklyTracking: 'iganädalase jälgimisega,',
    autoStatus: 'automaatse staatuse loogikaga,',
    clearDashboards: 'ja selgete töölaudadega juhtidele ja meeskondadele.',
    resultStatement: 'Tulemus ei ole lihtsalt parem aruandlus — vaid tugevam fookus, kiiremad otsused ja mõõdetavad tulemused.',
    whyTitle: 'Miks Outsprinter loodi',
    whyIntro: 'Outsprinter ei sündinud teooriast ega konsultatsiooni raamistikest. See sündis',
    realExperience: 'tegelikust juhtimiskogemusest',
    whyIntroEnd: '.',
    founderExperience: 'Asutaja ja tegevjuhina kogesin ise, kui kiiresti organisatsioonid kaotavad fookuse, kui:',
    whyPoint1: 'andmed elavad erinevates tööriistades,',
    whyPoint2: 'KPI-sid jälgitakse ebaregulaarselt,',
    whyPoint3: 'meeskonnad ei näe suurt pilti,',
    whyPoint4: 'ja juhtkond reageerib liiga hilja.',
    solutionNotMeetings: 'Lahendus polnud rohkem koosolekuid.',
    solutionWas: 'Lahendus oli',
    simpleVisual: 'lihtne, visuaalne ja distsiplineeritud tulemuslikkuse süsteem',
    thatForces: 'mis:',
    weeklyReflection: 'toimib distsiplineeritult iganädalase rütmina,',
    honestNumbers: 'kus fookuses on kõige tähtsamad prioriteedid ja numbrid,',
    clearOwnership: 'ning igal projektil ja taskil on selged eesmärgid ja vastutajad',
    builtToEnsure: 'Outsprinter loodi tagamaks, et:',
    ensurePoint1: 'strateegia ei jää slaididele,',
    ensurePoint2: 'eesmärgid ei sure tabelitesse,',
    ensurePoint3: 'ja täitmine saab osaks ettevõtte iganädalasest südamelöögist.',
    founder: 'Asutaja',
    connectLinkedIn: 'Ühenda LinkedInis',
    founderBio: 'Arti Kütt on ettevõtja, kes on loonud idufirmasid, juhtinud rahvusvahelisi tehnoloogia- ja e-kaubanduse ettevõtteid ning investeerib aktiivselt kohaliku äriinglina.',
    philosophyTitle: 'Meie filosoofia',
    belief1: 'Mida mõõdetakse iganädalaselt, seda parandatakse.',
    belief2: 'Mis on läbipaistev, selle eest võetakse vastutus.',
    belief3: 'Mis on visuaalne, saab mõistetud.',
    belief4: 'Mida jälgitakse järjekindlalt, annab tulemusi.',
    philosophyStatement: 'Me ehitame Outsprinterit asutajatele, tegevjuhtidele ja juhtmeeskondadele, kes ei taha vabandusi, kaost ega hilinenud reaktsioone — vaid tahavad',
    controlClarityResults: 'kontrolli, selgust ja tulemusi',
    visionTitle: 'Meie visioon',
    visionStatement: 'Saada kõige lihtsamaks ja usaldusväärsemaks tulemuslikkuse juhtimissüsteemiks juhtmeeskondadele üle Euroopa ja kaugemal — kus',
    strategyExecution: 'strateegia, igapäevatöö ning fookused ja vastutus',
    liveInOnePlace: 'elavad ühes kohas.',
  },

  // Auth page
  auth: {
    welcomeBack: 'Tere tulemast tagasi',
    createAccount: 'Loo oma konto',
    loginDesc: 'Sisesta oma andmed, et pääseda töölaudale',
    signupDesc: 'Alusta Outsprinteriga sekunditega',
    inviteDesc: 'Lõpeta oma konto seadistamine, et liituda meeskonnaga',
    continueWithGoogle: 'Jätka Google\'iga',
    orContinueWith: 'Või jätka',
    fullName: 'Täisnimi',
    email: 'E-post',
    password: 'Parool',
    agreeToTerms: 'Nõustun',
    termsOfService: 'Teenuse tingimustega',
    and: 'ja',
    privacyPolicy: 'Privaatsuspoliitikaga',
    forgotPassword: 'Unustasid parooli?',
    signIn: 'Logi sisse',
    signingIn: 'Sisselogimine...',
    createAccountBtn: 'Loo konto',
    creatingAccount: 'Konto loomine...',
    noAccount: 'Pole kontot?',
    haveAccount: 'On juba konto?',
    signUp: 'Registreeru',
    resetPassword: 'Lähtesta parool',
    resetDesc: 'Sisesta oma e-posti aadress ja saadame sulle parooli lähtestamise lingi.',
    resetSent: 'Kontrolli oma e-posti parooli lähtestamise lingi saamiseks.',
    resetSentTo: 'Saatsime parooli lähtestamise lingi aadressile',
    checkSpam: 'Ei saanud? Kontrolli rämpsposti kausta või proovi uuesti.',
    tryDifferentEmail: 'Proovi teist e-posti',
    done: 'Valmis',
    emailAddress: 'E-posti aadress',
    sendResetLink: 'Saada lähtestamise link',
    sendingReset: 'Saatmine...',
  },

  // Contact page
  contact: {
    title: 'Võta ühendust Outsprinteriga',
    subtitle: 'Oleme siin, et aidata sul paremini eesmärgid ellu viia!',
    description: 'Olenemata sellest, kas hindad Outsprinterit, vajad tuge või soovid uurida, kuidas see sinu organisatsiooniga sobib, meie meeskond on valmis aitama.',
    getInTouch: '📩 Võta ühendust',
    formIntro: 'Kasuta kontaktvormi, et pöörduda meie poole seoses:',
    productQuestions: 'Toote küsimused',
    salesInquiries: 'Müügipäringud',
    enterprisePricing: 'Ettevõtte hinnakiri',
    onboardingTraining: 'Juurutamine ja koolitus',
    supportRequests: 'Tugipäringud',
    partnerships: 'Partnerlused',
    name: 'Nimi',
    yourName: 'Sinu nimi',
    email: 'E-post',
    yourEmail: 'sinu@email.ee',
    company: 'Ettevõte',
    yourCompany: 'Sinu ettevõte',
    message: 'Sõnum',
    howCanWeHelp: 'Kuidas saame aidata?',
    sendMessage: 'Saada sõnum',
    responseTime: 'Tavaliselt vastame ühe tööpäeva jooksul.',
    salesDemos: '🧭 Müük ja demod',
    salesDesc: 'Soovid näha Outsprinterit tegevuses või arutada hinnakiri?',
    bookDemo: 'Broneeri demo',
    bookLiveDemo: 'Broneeri live demo',
    requestEnterprise: 'Küsi ettevõtte hinnakiri',
    customerSupport: '🛠️ Klienditugi',
    supportDesc: 'Oled juba klient ja vajad abi?',
    inAppSupport: 'Rakendusesisene tugi',
    emailSupportLabel: 'E-posti tugi',
    helpCenterResources: 'Abikeskuse ressursid',
    visitHelpCenter: 'Külasta abikeskust',
    generalInquiries: '📧 Üldised päringud',
    generalDesc: 'Partnerluste, meedia või üldiste küsimuste korral:',
    responseWithin24h: 'Vastamisaeg: 24 tunni jooksul',
    ourApproach: '🌍 Meie lähenemine',
    supportShouldBe: 'Usume, et tugi peaks olema:',
    fast: 'Kiire',
    clear: 'Selge',
    human: 'Inimlik',
    focusedOnOutcomes: 'Tulemustele suunatud',
    noTicketBlackHoles: 'Ükski pöördumine ei jää tähelepanuta ning väldime tarbetut edasi-tagasi suhtlust.',
    letsTalk: '📣 Räägime tõhusast elluviimisest!',
    contactUsBtn: 'Võta ühendust',
  },

  // FAQ page
  faq: {
    title: 'Korduma kippuvad küsimused',
    subtitle: 'Selged vastused levinud küsimustele Outsprinteri kohta.',
    stillHaveQuestions: '📣 Veel küsimusi? Oleme siin, et aidata.',
    contactSupport: 'Võta ühendust tugiga',
    bookDemo: 'Broneeri demo',
    productFunctionality: '🧠 Toode ja funktsionaalsus',
    kpisSprints: '📊 KPI-d ja sprindid',
    aiAssistant: '🧠 AI assistent',
    usersAccounts: '👥 Kasutajad ja kontod',
    pricingBilling: '💳 Hinnakiri ja arveldus',
    securityPrivacy: '🔐 Turvalisus ja privaatsus',
    support: '🛠️ Tugi',
    whatIsOutsprinter: 'Mis on Outsprinter?',
    whatIsOutsprinterA: 'Outsprinter on B2B täitmisplatvorm, mis aitab ettevõtetel seada KPI-sid, planeerida iganädalasi sprinte, jälgida täitmist ja saada AI-põhiseid ülevaateid — kõik ühes kohas.',
    isProjectMgmt: 'Kas Outsprinter on projektijuhtimise tööriist?',
    isProjectMgmtA: 'Ei. Outsprinter keskendub täitmisele, tulemustele ja KPI-dele. See täiendab projektitööriistu nagu Jira või Asana, mitte ei asenda neid.',
    whatMakesDifferent: 'Mis teeb Outsprinteri erinevaks?',
    whatMakesDifferentA: 'Outsprinter ühendab strateegia, KPI-d, iganädalase rütmi, sprindid ja AI ülevaated üheks täitmise operatsioonisüsteemiks.',
    howOftenUpdate: 'Kui tihti tuleks KPI-sid uuendada?',
    howOftenUpdateA: 'Outsprinter on üles ehitatud iganädalasele rütmile. Iganädalased uuendused annavad kiire tagasiside ja parema täitmisdistsipliini.',
    howManyKpis: 'Mitu KPI-d peaksime jälgima?',
    howManyKpisA: 'Enamik meeskondi toimib kõige paremini 3–7 KPI-ga meeskonna või osakonna kohta.',
    canKpisRollUp: 'Kas KPI-d koonduvad ettevõtte tasandi eesmärkideks?',
    canKpisRollUpA: 'Jah. KPI puu struktuur võimaldab täielikku koondvaate.',
    whatDoesAiDo: 'Mida AI assistent teeb?',
    whatDoesAiDoA: 'AI assistent analüüsib KPI-sid ja sprinte, tuvastab riske, genereerib kokkuvõtteid ja soovitab parandusi.',
    doesAiDecide: 'Kas AI teeb otsuseid automaatselt?',
    doesAiDecideA: 'Ei. AI annab ülevaateid ja soovitusi — inimesed jäävad kontrolli juurde.',
    isDataUsedForAi: 'Kas meie andmeid kasutatakse avalike AI mudelite treenimiseks?',
    isDataUsedForAiA: 'Ei. Klientide andmed on eraldatud ja neid ei kasutata kunagi avalike mudelite treenimiseks.',
    canInviteExternal: 'Kas saame kutsuda väliseid kasutajaid?',
    canInviteExternalA: 'Jah, administraatorid saavad kasutajaid kutsuda ja rolle määrata.',
    multipleCompanies: 'Kas kasutajad saavad kuuluda mitmesse ettevõttesse?',
    multipleCompaniesA: 'Iga kasutaja kuulub korraga ühte ettevõttesse andmete eraldatuse ja turvalisuse tagamiseks.',
    roleBasedSupported: 'Kas rollipõhine ligipääs on toetatud?',
    roleBasedSupportedA: 'Jah. Outsprinter toetab administraatori, halduri, kasutaja ja vaataja rolle.',
    isFreeTrial: 'Kas on tasuta prooviperiood?',
    isFreeTrialA: 'Jah. Outsprinter on kõigile täiesti tasuta — kõik funktsioonid sisalduvad, krediitkaarti pole vaja.',
    canChangePlans: 'Kas saame plaani hiljem muuta?',
    canChangePlansA: 'Jah. Plaane saab igal ajal uuendada või alandada.',
    nonprofitDiscounts: 'Kas pakute mittetulundusühingutele allahindlusi?',
    nonprofitDiscountsA: 'Jah. Kinnitatud mittetulundusühingud saavad soodushinnaga.',
    isGdpr: 'Kas Outsprinter vastab GDPR nõuetele?',
    isGdprA: 'Jah. Outsprinter on loodud GDPR põhimõtteid silmas pidades.',
    whereDataStored: 'Kus andmeid hoitakse?',
    whereDataStoredA: 'Andmeid hoitakse turvaliselt pilveinfrastruktuuris krüpteerimisega nii salvestamisel kui edastamisel.',
    canExportDelete: 'Kas saame oma andmeid eksportida või kustutada?',
    canExportDeleteA: 'Jah. Administraatorid saavad andmeid eksportida ja taotleda täielikku kustutamist.',
    whatSupportOptions: 'Millised tugivalikud on saadaval?',
    whatSupportOptionsA: 'E-posti tugi, rakendusesisene abi, juurutamise sessioonid ja ettevõtte tugivõimalused.',
    offerOnboarding: 'Kas pakute juurutamist?',
    offerOnboardingA: 'Jah. Juhendatud juurutamine on saadaval meeskondadele ja ettevõtetele.',
  },

  // Help Center page
  helpCenter: {
    title: 'Abikeskus',
    subtitle: 'Kõik, mida vajad Outsprinterist väärtuse saamiseks — kiiresti.',
    description: 'Olenemata sellest, kas oled tegevjuht, meeskonnajuht või meeskonnaliige, leiad siit selge juhendamise, samm-sammult juhised ja praktilised näited.',
    structureTitle: '🔍 Kuidas abikeskus on üles ehitatud',
    needMoreHelp: '📣 Vajad rohkem abi?',
    cantFind: 'Kui ei leia otsitut:',
    contactFromApp: 'Võta tugitiimiga ühendust otse rakendusest',
    emailSupport: 'Saada meile e-kiri',
    bookOnboarding: 'Broneeri juhendatud juurutamise sessioon',
    contactSupportBtn: 'Võta ühendust tugiga',
    bookOnboardingBtn: 'Broneeri juurutamise sessioon',
    gettingStartedTitle: 'Alustamine',
    gettingStartedDesc: 'Ideaalne uutele kasutajatele ja meeskondadele.',
    kpiGuidesTitle: 'KPI halduri juhendid',
    kpiGuidesDesc: 'Õpi, kuidas kujundada ja jälgida tähendusrikkaid KPI-sid.',
    sprintManagerTitle: 'Meeskonna sprindi haldur',
    sprintManagerDesc: 'Omanda iganädalane täitmine ja sprindi planeerimine.',
    aiAssistantTitle: 'Nutikas AI assistent',
    aiAssistantDesc: 'Saa AI-põhistest ülevaadetest maksimum.',
    dashboardsTitle: 'Töölauad ja aruandlus',
    dashboardsDesc: 'Õpi töölaudu tõlgendama ja kasutama.',
    userCompanyMgmtTitle: 'Kasutajate ja ettevõtte haldus',
    userCompanyMgmtDesc: 'Administraatoritasandi seadistamine ja kontroll.',
    securityTitle: 'Turvalisus, privaatsus ja vastavus',
    securityDesc: 'Mõista, kuidas Outsprinter sinu andmeid kaitseb.',
    troubleshootingTitle: 'Veaotsing ja tugi',
    troubleshootingDesc: 'Kiired vastused levinud probleemidele.',
    // Topics
    gs1: 'Konto ja ettevõtte loomine',
    gs2: 'Kasutajate kutsumine ja rollide määramine',
    gs3: 'Esimeste KPI-de seadistamine',
    gs4: 'KPI puu mõistmine',
    gs5: 'Esimese iganädalase sprindi planeerimine',
    kpi1: 'Kuidas defineerida tõhusaid KPI-sid',
    kpi2: 'Ettevõtte vs osakonna KPI-d',
    kpi3: 'Iganädalase KPI uuendamise parimad tavad',
    kpi4: 'KPI künnised (roheline / kollane / punane)',
    kpi5: 'KPI omandiõigus ja vastutus',
    kpi6: 'KPI trendid ja prognoosimine',
    sp1: 'Kuidas planeerida iganädalasi sprinte',
    sp2: 'Sprindi prioriteetide valimine',
    sp3: 'Sprindi ülevaated ja retrospektiivid',
    sp4: 'Ülekoormatuse vältimine',
    sp5: 'Sprindi edukuse mõõtmine',
    ai1: 'Kuidas AI genereerib ülevaateid',
    ai2: 'AI soovitatud KPI-d ja sprindid',
    ai3: 'AI riskihoiatuste mõistmine',
    ai4: 'AI kokkuvõtted ja aruanded',
    ai5: 'Kuidas AI aja jooksul paraneb',
    dash1: 'Ettevõtteülesed töölauad',
    dash2: 'Meeskonna töölauad',
    dash3: 'Juhatuse tasandi vaated',
    dash4: 'Prognoos ja trendianalüüs',
    dash5: 'Aruannete eksportimine (PDF, CSV)',
    ucm1: 'Kasutajate ja rollide haldamine',
    ucm2: 'Ettevõtte profiili seaded',
    ucm3: 'Õigused ja ligipääsu kontroll',
    ucm4: 'Arvelduse ja tellimuse haldus',
    ucm5: 'Auditilogi',
    sec1: 'Andmeturbe ülevaade',
    sec2: 'GDPR vastavus',
    sec3: 'Ligipääsu logimine ja auditijäljed',
    sec4: 'Andmete eksport ja kustutamine',
    ts1: 'Sisselogimise ja ligipääsu probleemid',
    ts2: 'KPI uuendamise probleemid',
    ts3: 'Sprindi nähtavuse probleemid',
    ts4: 'Teavituste veaotsing',
  },

  // Use case shared
  useCaseCta: {
    startFreeTrial: 'Loo konto →',
    bookDemo: 'Broneeri demo',
  },

  // Related links
  relatedLinks: {
    exploreFeatures: 'Avasta platvormi funktsioonid',
    exploreUseCases: 'Avasta kasutusjuhud',
    moreUseCases: 'Rohkem kasutusjuhte',
    moreFeatures: 'Rohkem funktsioone',
  },

  // Feature Page - Execution Management
  fpExec: {
    seoTitle: 'Elluviimise juhtimise tarkvara | KPI\'d, ülesanded ja projektid ühes süsteemis',
    seoDesc: 'Kõik-ühes elluviimise juhtimise tarkvara, mis joondab strateegia, KPI\'d, ülesanded ja projektid. Saavuta täielik nähtavus ja paranda ettevõtte tulemuslikkust.',
    badge: 'Elluviimise juhtimine',
    heroTitle: 'Elluviimise juhtimise platvorm',
    heroSubtitle: 'Muuda strateegia mõõdetavaks elluviimiseks.',
    heroDesc: 'Enamik ettevõtteid ei läbi kukku halva strateegia pärast — nad kukuvad läbi, sest elluviimine on killustunud. Outsprinter on elluviimise juhtimise platvorm, mis ühendab eesmärgid, KPI\'d, projektid ja ülesanded ühte süsteemi — andes juhtkonnale ja meeskondadele ühise tõealuse.',
    startTrial: 'Loo konto',
    whatTitle: 'Mis on elluviimise juhtimine?',
    whatIntro: 'Elluviimise juhtimine tagab, et:',
    what1: 'Strateegilised eesmärgid on selgelt defineeritud',
    what2: 'Edenemist mõõdetakse KPI\'de abil',
    what3: 'Elluviimist juhitakse ülesannete ja projektide kaudu',
    what4: 'Juhtkond omab reaalajas ülevaadet',
    whatConclusion: 'See ühendab planeerimise → elluviimise → tulemused.',
    whyBreaksTitle: 'Miks elluviimine ebaõnnestub',
    breaks1: 'KPI\'d jälgitud, kuid mitte seotud tööga',
    breaks2: 'Ülesanded tehtud, kuid ilma mõjuta',
    breaks3: 'Projekte juhitakse ilma nähtavuseta',
    breaks4: 'Andmed hajutatud eri tööriistade vahel',
    breaks5: 'Juhtkond näeb tulemusi liiga hilja',
    howTitle: 'Kuidas Outsprinter selle lahendab',
    howIntro: 'Outsprinter loob pideva elluviimise tsükli:',
    howLoop: 'Eesmärgid → KPI\'d → Projektid → Ülesanded → Ülevaated → Otsused',
    howLoopDesc: 'Kõik on omavahel ühendatud ja uuendatud reaalajas.',
    coreTitle: 'Elluviimise juhtimise põhifunktsioonid',
    sec1Title: 'KPI haldus (tulemuslikkuse kiht)',
    sec1Desc: 'Jälgi tulemuslikkust organisatsiooni igal tasandil.',
    sec1a: 'Reaalajas KPI töölauad',
    sec1b: 'Iganädalane tulemuslikkuse jälgimine',
    sec1c: 'KPI vastutus ja omandisuhted',
    sec1d: 'Visuaalsed staatuse indikaatorid (roheline / kollane / punane)',
    sec1e: 'KPI hierarhia (ettevõte → osakond → meeskond)',
    sec1f: 'Ajaloolised trendid ja tulemuslikkuse võrdlus',
    sec1Result: 'Juhtkond teab alati, kuidas ettevõttel läheb.',
    sec2Title: 'Ülesannete haldus (elluviimise kiht)',
    sec2Desc: 'Muuda strateegia tegevusteks.',
    sec2a: 'Ülesannete loomine prioriteetide ja tähtaegadega',
    sec2b: 'Alamülesanded (mitmetasandilised keerukate töövoogude jaoks)',
    sec2c: 'Korduvad ülesanded operatiivsete rutiinide jaoks',
    sec2d: 'Ülesannete dubleerimine mitmele kasutajale',
    sec2e: 'Selge vastutus ja omandisuhted',
    sec2f: 'Reaalajas staatuse uuendused',
    sec2g: 'Teavitused muudatustest ja tähtaegadest',
    sec2Result: 'Miski ei jää kahe silma vahele.',
    sec3Title: 'Projektihaldus (struktuuri kiht)',
    sec3Desc: 'Korrasta töö mõõdetavateks algatusteks.',
    sec3a: 'Projektipõhine töökorraldus',
    sec3b: 'Projekti tervise jälgimine',
    sec3c: 'Edenemise jälgimine ülesannete lõikes',
    sec3d: 'Töökoormuse ja võimekuse nähtavus',
    sec3e: 'Meeskondade ülene koostöö',
    sec3f: 'Ajatelje ja verstapostide jälgimine',
    sec3Result: 'Projektid muutuvad prognoositavaks ja läbipaistvaks.',
    sec4Title: 'Eesmärkide planeerija (strateegiline kiht)',
    sec4Desc: 'Tõlgi pikaajaline strateegia elluviimiseks.',
    sec4a: 'Defineeri aastased või kvartaalsed eesmärgid',
    sec4b: 'Jaga eesmärgid mõõdetavateks KPI\'deks',
    sec4c: 'Jälgi edenemist pidevalt',
    sec4d: 'Joonda kogu töö strateegiliste prioriteetidega',
    sec4Result: 'Strateegia muutub teostatavaks.',
    sec5Title: 'Töölauad (nähtavuse kiht)',
    sec5Desc: 'Täielik reaalajas nähtavus kogu ettevõttes.',
    sec5a: 'Ettevõtte tasandi töölauad',
    sec5b: 'Osakondade tulemuslikkuse vaated',
    sec5c: 'Projektide ja ülesannete nähtavus',
    sec5d: 'Kohesed uuendused andmete muutumisel',
    sec5e: 'Süvitsi analüüsimise võimalus',
    sec5Result: 'Enam ei pea aruandeid ootama.',
    sec6Title: 'AI assistent (ülevaadete kiht)',
    sec6Desc: 'Muuda andmed teostatavaks otsusteks.',
    sec6a: 'Analüüsi KPI trende',
    sec6b: 'Tuvasta riskid ja anomaaliad',
    sec6c: 'Soovita parendusi',
    sec6d: 'Aita defineerida paremaid KPI\'sid',
    sec6e: 'Paku tulemuslikkuse kokkuvõtteid',
    sec6Result: 'Kiirem ja targem otsustamine.',
    result: 'Tulemus',
    add1Title: 'Kasutajate ja organisatsiooni haldus',
    add1Desc: 'Kontrolli struktuuri ja ligipääsu.',
    add1a: 'Rollipõhised õigused',
    add1b: 'Osakondade tasandi nähtavus',
    add1c: 'Organisatsiooni hierarhia',
    add1d: 'Turvaline andmete eraldamine',
    add2Title: 'Teavitused ja hoiatused',
    add2Desc: 'Püsi kursis ilma mikrojuhtimiseta.',
    add2a: 'Ülesannete uuendused',
    add2b: 'KPI muudatused',
    add2c: 'Projekti edenemise hoiatused',
    add3Title: 'Andmete import ja eksport',
    add3Desc: 'Integreeri olemasolevate töövooga.',
    add3a: 'Impordi KPI andmeid Excelist',
    add3b: 'Ekspordi aruandeid CSV-formaadis',
    add3c: 'Kasuta andmeid väliselt',
    benefitsTitle: 'Elluviimise juhtimise eelised',
    ben1: 'Täielik nähtavus',
    ben2: 'Kiiremad otsused',
    ben3: 'Selge vastutus',
    ben4: 'Parem joondamine',
    ben5: 'Vähenenud keerukus',
    featuresLink: 'Funktsioonide ülevaade',
    pricingLink: 'Hinnad',
    ctaTitle: 'Valmis muutma strateegiat elluviimiseks?',
    ctaDesc: 'Alusta tasuta ja näe tulemusi juba esimesel nädalal.',
  },

  // Feature Page - KPI Management
  fpKPI: {
    seoTitle: 'KPI juhtimise tarkvara | Reaalajas KPI\'de jälgimine ja töölauad',
    seoDesc: 'Jälgi, analüüsi ja tegutse KPI\'de alusel reaalajas. Ühenda mõõdikud elluviimisega Outsprinteris.',
    badge: 'KPI juhtimine',
    heroTitle: 'KPI juhtimise tarkvara',
    heroSubtitle: 'Jälgi tulemuslikkust. Juhi otsuseid. Paranda tulemusi.',
    heroDesc: 'Enamik KPI tööriistu piirduvad töölaudadega. Outsprinter läheb kaugemale — ühendab KPI\'d otse elluviimisega.',
    startTrial: 'Loo konto',
    featuresTitle: 'Täiustatud KPI funktsioonid',
    feat1Title: 'Reaalajas KPI jälgimine',
    feat1a: 'Kohesed uuendused',
    feat1b: 'Iganädalane jälgimise rütm',
    feat1c: 'Mitte aegunud aruanded',
    feat2Title: 'KPI hierarhia (KPI puu)',
    feat2a: 'Ettevõte → osakond → meeskonna KPI\'d',
    feat2b: 'Täielik joondamise nähtavus',
    feat3Title: 'KPI vastutus',
    feat3a: 'Määra vastutus',
    feat3b: 'Selge aruandekohustus',
    feat4Title: 'KPI staatuse süsteem',
    feat4a: 'Roheline / kollane / punane indikaatorid',
    feat4b: 'Kohene probleemide nähtavus',
    feat5Title: 'Trendid ja ajalooline analüüs',
    feat5a: 'Jälgi tulemuslikkust ajas',
    feat5b: 'Võrdle perioode',
    feat6Title: 'KPI → ülesannete ja projektide seos',
    feat6a: 'Ühenda KPI\'d otse elluviimisega',
    feat6b: 'Tegutse kohe tulemuslikkuse muutuste puhul',
    feat7Title: 'AI-põhised ülevaated',
    feat7a: 'Tuvasta anomaaliaid',
    feat7b: 'Too esile riskid',
    feat7c: 'Soovita parendusi',
    blogLink: 'Loe blogi ülevaateid',
    ctaTitle: 'Valmis oma KPI\'sid kontrollima?',
    ctaDesc: 'Alusta tulemuslikkuse jälgimist reaalajas.',
  },

  // Feature Page - Task Management
  fpTask: {
    seoTitle: 'Täiustatud ülesannete halduse tarkvara | Ülesanded, alamülesanded ja korduvad tööd',
    seoDesc: 'Halda ülesandeid täisstruktuuriga: alamülesanded, korduvad ülesanded, prioriteedid ja tähtajad. Paranda elluviimist ja vastutust.',
    badge: 'Ülesannete haldus',
    heroTitle: 'Ülesannete halduse tarkvara',
    heroSubtitle: 'Struktureeri tööd. Paranda elluviimist. Saavuta tulemusi.',
    heroDesc: 'Outsprinter ei ole lihtsalt ülesannete tööriist — see ühendab ülesanded tulemustega.',
    startTrial: 'Loo konto',
    featuresTitle: 'Täiustatud ülesannete funktsioonid',
    feat1Title: 'Ülesannete määramine',
    feat1a: 'Määra üksikisikutele',
    feat1b: 'Selge vastutus',
    feat2Title: 'Alamülesanded (mitmetasandilised)',
    feat2a: 'Jaga keerukas töö osadeks',
    feat2b: 'Mitu tasandit',
    feat3Title: 'Korduvad ülesanded',
    feat3a: 'Automatiseeri rutiinid',
    feat3b: 'Igapäevane / iganädalane / igakuine',
    feat4Title: 'Ülesannete dubleerimine',
    feat4a: 'Määra sama ülesanne mitmele kasutajale',
    feat5Title: 'Prioriteedid ja tähtajad',
    feat5a: 'Keskendu olulisele',
    feat6Title: 'Ülesannete nähtavus',
    feat6a: 'Meeskondade ja osakondade üleselt',
    feat7Title: 'Teavitused',
    feat7a: 'Reaalajas uuendused',
    outcomeTitle: 'Tulemus',
    out1: 'Kõrgem tootlikkus',
    out2: 'Parem vastutus',
    out3: 'Struktureeritud elluviimine',
    ctaTitle: 'Valmis oma meeskonna elluviimist struktureerima?',
    ctaDesc: 'Alusta tasuta juba täna.',
  },

  // Feature Page - Project Management
  fpProject: {
    seoTitle: 'Projektijuhtimise tarkvara koos KPI jälgimisega | Outsprinter',
    seoDesc: 'Halda projekte, jälgi edenemist ja joonda töö ärieesmärkidega. Täielik nähtavus ühes süsteemis.',
    badge: 'Projektijuhtimine',
    heroTitle: 'Projektijuhtimise tarkvara',
    heroSubtitle: 'Halda projekte selguse, kontrolli ja tegeliku mõjuga.',
    startTrial: 'Loo konto',
    featuresTitle: 'Täiustatud projekti funktsioonid',
    feat1Title: 'Projekti struktuur',
    feat1a: 'Korrasta töö projektideks',
    feat1b: 'Selge vastutus',
    feat2Title: 'Edenemise jälgimine',
    feat2a: 'Reaalajas edenemine',
    feat2b: 'Seotud ülesanded',
    feat3Title: 'Projekti tervise mõõdikud',
    feat3a: 'Staatuse indikaatorid',
    feat3b: 'Riski nähtavus',
    feat4Title: 'Töökoormuse haldus',
    feat4a: 'Tasakaalusta meeskonna võimekust',
    feat4b: 'Väldi ülekoormust',
    feat5Title: 'KPI integratsioon',
    feat5a: 'Ühenda projektid tulemustega',
    feat6Title: 'Meeskondade ülene koostöö',
    feat6a: 'Tööta osakondade üleselt',
    consultingLink: 'Konsultatsiooni tugi',
    ctaTitle: 'Valmis projekte mõjusalt juhtima?',
    ctaDesc: 'Alusta tasuta ja too oma projektidesse selgus.',
  },

  // Terms of Service
  terms: {
    title: 'Teenuse tingimused',
    effectiveDate: 'Jõustumiskuupäev',
    intro: 'Tere tulemast Outsprinterisse. Need teenuse tingimused ("Tingimused") reguleerivad teie juurdepääsu Outsprinteri platvormile, veebisaidile ja teenustele ("Teenus") ning nende kasutamist.',
    agreement: 'Konto loomisel või teenuse kasutamisel nõustute nende tingimustega.',
    s1Title: '1. Mõisted',
    s1d1: 'viitab ettevõttele, mis opereerib Outsprinteri platvormi.',
    s1d2: 'viitab isikule või üksusele, kes kasutab teenust.',
    s1d3: 'tähendab registreeritud kasutajakontot.',
    s1d4: 'tähendab Outsprinteris loodud organisatsiooni.',
    s1d5: 'tähendab kõiki andmeid, KPI-sid, teksti ja teavet, mis on teenusesse sisestatud.',
    s2Title: '2. Teenuse kasutamine',
    s2p1: 'Te võite teenust kasutada ainult kooskõlas nende tingimuste ja kehtivate seadustega.',
    s2agree: 'Te nõustute',
    s2a1: 'Esitama täpset kontoteavet',
    s2a2: 'Hoidma oma sisselogimisandmeid turvalisena',
    s2a3: 'Kasutama teenust ainult seaduslikel ärilistel eesmärkidel',
    s2mustNot: 'Te ei tohi',
    s2n1: 'Pääseda ligi teise ettevõtte andmetele',
    s2n2: 'Pöördprojekteerida või platvormi kuritarvitada',
    s2n3: 'Häirida süsteemi turvalisust või kättesaadavust',
    s3Title: '3. Kontod ja ligipääs',
    s3p1: 'Igal kasutajal peab olema unikaalne konto',
    s3p2: 'Kasutajad kuuluvad ühte ettevõtte tööruumi',
    s3p3: 'Administraatorid vastutavad ligipääsu ja õiguste haldamise eest',
    s3p4: 'Te vastutate kogu tegevuse eest oma konto all',
    s4Title: '4. Hinnastamine',
    s4p1: 'Outsprinter on praegu kõigile kasutajatele tasuta',
    s4p2: 'Teenuse kasutamiseks ei ole vaja makset, krediitkaarti ega tellimust',
    s4p3: 'Jätame õiguse tulevikus etteteatamisega kasutusele võtta tasulisi plaane või funktsioone',
    s4p4: 'Kuritarvitamise vältimiseks ja teenuse stabiilsuse tagamiseks võib rakendada mõistlikke kasutuspiiranguid',
    s4warning: 'Liigne automatiseeritud või kuritarvituslik kasutamine võib kaasa tuua piirangud või konto peatamise.',
    s5Title: '5. Vastutustundlik kasutamine',
    s5intro: 'Et hoida teenus tasuta ja töökindel kõigile, nõustute mitte',
    s5p1: 'Kasutama teenust automatiseeritud massitoiminguteks väljaspool tavapärast äritegevust',
    s5p2: 'Looma piirangutest kõrvalehoidmiseks mitut kontot',
    s5p3: 'Edasi müüma, all-litsentsima ega ärilisel eesmärgil edasi jagama juurdepääsu teenusele',
    s6Title: '6. Kliendi sisu',
    s6p1: 'Te säilitate omandiõiguse kõigile oma esitatud andmetele ja sisule.',
    s6p2: 'Te annate Outsprinterile piiratud litsentsi',
    s6l1: 'Salvestada',
    s6l2: 'Töödelda',
    s6l3: 'Kuvada',
    s6p3: 'teie sisu ainult teenuse osutamiseks.',
    s6noAi: 'Me ei kasuta kliendi andmeid avalike AI mudelite treenimiseks.',
    s7Title: '7. AI funktsioonid',
    s7p1: 'Outsprinter pakub AI-genereeritud ülevaateid ja soovitusi.',
    s7p2: 'Te kinnitate',
    s7l1: 'AI väljundid on ainult informatiivsed',
    s7l2: 'Lõplikud otsused jäävad teie vastutusele',
    s7l3: 'AI ei asenda professionaalset otsustusviisi',
    s8Title: '8. Andmekaitse ja privaatsus',
    s8p1: 'Me töötleme isikuandmeid kooskõlas meie privaatsusteate ja kehtivate andmekaitsseadustega, sealhulgas GDPR-iga.',
    s9Title: '9. Turvalisus',
    s9p1: 'Me rakendame mõistlikke tehnilisi ja organisatsioonilisi meetmeid teie andmete kaitsmiseks. Siiski ei saa ükski süsteem tagada absoluutset turvalisust.',
    s10Title: '10. Lõpetamine',
    s10p1: 'Te võite oma konto igal ajal lõpetada.',
    s10p2: 'Me võime ligipääsu peatada või lõpetada, kui',
    s10l1: 'Neid tingimusi on rikutud',
    s10l2: 'Seadusega nõutud',
    s10l3: 'Vastutustundliku kasutamise reegleid ei ole täidetud',
    s10p3: 'Lõpetamisel võidakse andmed kustutada vastavalt säilitamispoliitikatele.',
    s11Title: '11. Vastutuse piiramine',
    s11intro: 'Seadusega lubatud maksimaalses ulatuses',
    s11l1: 'Outsprinter ei vastuta kaudsete ega järelduslike kahjude eest',
    s11l2: 'Koguvastutus ei ületa eelmise 12 kuu jooksul makstud tasusid',
    s12Title: '12. Tingimuste muudatused',
    s12p1: 'Me võime neid tingimusi aeg-ajalt uuendada. Teenuse jätkuv kasutamine tähendab uuendatud tingimuste aktsepteerimist.',
    s13Title: '13. Kohaldatav õigus',
    s13p1: 'Neid tingimusi reguleerivad Euroopa Liidu seadused ja kohaldatav kohalik jurisdiktsioon.',
    s14Title: '14. Kontakt',
    s14p1: 'Küsimuste korral nende tingimuste kohta',
  },

  // Privacy Notice
  privacy: {
    title: 'Privaatsusteade',
    effectiveDate: 'Jõustumiskuupäev',
    intro: 'See privaatsusteade selgitab, kuidas Outsprinter kogub, kasutab ja kaitseb isikuandmeid.',
    s1Title: '1. Vastutav töötleja',
    s1p1: 'Outsprinter tegutseb teenuse kaudu töödeldavate isikuandmete vastutava töötlejana.',
    s2Title: '2. Andmed, mida kogume',
    s2intro: 'Me võime koguda',
    s2l1: 'Nimi',
    s2l2: 'E-posti aadress',
    s2l3: 'Ettevõtte teave',
    s2l4: 'Sisselogimise ja kasutusandmed',
    s2l5: 'Valikulised profiili- ja ettevõtte andmed',
    s3Title: '3. Kuidas me andmeid kasutame',
    s3intro: 'Me kasutame isikuandmeid',
    s3l1: 'Teenuse pakkumiseks ja opereerimiseks',
    s3l2: 'Kasutajate autentimiseks',
    s3l3: 'Tehinguliste ja tootega seotud teadete saatmiseks',
    s3l4: 'Toote funktsionaalsuse parandamiseks',
    s3l5: 'Klienditoe pakkumiseks',
    s3l6: 'Juriidiliste kohustuste täitmiseks',
    s4Title: '4. Töötlemise õiguslik alus',
    s4intro: 'Me töötleme andmeid järgmistel alustel',
    s4l1: 'Lepinguline vajadus',
    s4l2: 'Õigustatud ärilised huvid',
    s4l3: 'Juriidilised kohustused',
    s4l4: 'Kasutaja nõusolek (vajadusel)',
    s5Title: '5. Andmete jagamine',
    s5noSell: 'Me ei müü isikuandmeid.',
    s5share: 'Me võime andmeid jagada',
    s5l1: 'Hostimise ja infrastruktuuri pakkujad',
    s5l2: 'E-kirjade saatmise teenusepakkujad',
    s5l3: 'Analüütikateenused',
    s5l4: 'Õigusasutused vajadusel',
    s5bound: 'Kõik partnerid on lepinguliselt kohustatud andmeid kaitsma.',
    s6Title: '6. Andmete säilitamine',
    s6intro: 'Me säilitame isikuandmeid ainult nii kaua, kui vajalik',
    s6l1: 'Teenuse pakkumiseks',
    s6l2: 'Juriidiliste nõuete täitmiseks',
    s7Title: '7. Teie õigused (GDPR)',
    s7intro: 'Teil on õigus',
    s7l1: 'Pääseda ligi oma andmetele',
    s7l2: 'Parandada ebatäpseid andmeid',
    s7l3: 'Taotleda kustutamist',
    s7l4: 'Piirata või vaidlustada töötlemist',
    s7l5: 'Eksportida oma andmeid',
    s7request: 'Taotlusi saab esitada aadressil',
    s8Title: '8. Turvameetmed',
    s8intro: 'Me kasutame',
    s8l1: 'Krüpteerimist edastamisel ja salvestamisel',
    s8l2: 'Ligipääsukontrolle',
    s8l3: 'Auditilogimist',
    s8l4: 'Turvalist pilveinfrastruktuuri',
    s9Title: '9. Rahvusvahelised edastamised',
    s9p1: 'Kui andmeid edastatakse väljaspool EL-i, kohaldatakse asjakohaseid kaitsemeetmeid.',
    s10Title: '10. Muudatused',
    s10p1: 'Me võime seda privaatsusteadet uuendada. Olulistest muudatustest teavitatakse.',
    s11Title: '11. Kontakt',
    s11p1: 'Privaatsusega seotud küsimuste korral',
  },

  // Cookie Policy
  cookie: {
    title: 'Küpsiste poliitika',
    effectiveDate: 'Jõustumiskuupäev',
    intro: 'See küpsiste poliitika selgitab, kuidas Outsprinter kasutab küpsiseid ja sarnaseid tehnoloogiaid.',
    s1Title: '1. Mis on küpsised?',
    s1p1: 'Küpsised on väikesed tekstifailid, mis salvestatakse teie seadmesse veebisaidi funktsionaalsuse ja kasutajakogemuse parandamiseks.',
    s2Title: '2. Küpsiste tüübid, mida kasutame',
    essential: 'Hädavajalikud küpsised',
    essentialFor: 'Vajalikud',
    e1: 'Autentimine',
    e2: 'Turvalisus',
    e3: 'Põhifunktsionaalsus',
    cannotDisable: 'Neid ei saa keelata.',
    analytics: 'Analüütikaküpsised',
    analyticsFor: 'Kasutatakse mõistmiseks',
    a1: 'Platvormi kasutus',
    a2: 'Funktsioonide jõudlus',
    a3: 'Liiklusmustrid',
    analyticsHelp: 'Need aitavad meil teenust parandada.',
    functional: 'Funktsionaalsed küpsised',
    functionalFor: 'Kasutatakse',
    f1: 'Eelistuste meeldejätmine',
    f2: 'Kasutatavuse parandamine',
    s3Title: '3. Küpsiste haldamine',
    s3p1: 'Saate küpsiseid hallata või keelata brauseri seadete kaudu.',
    s3note: 'Märkus: Hädavajalike küpsiste keelamine võib mõjutada funktsionaalsust.',
    s4Title: '4. Kolmandate osapoolte küpsised',
    s4p1: 'Me võime kasutada usaldusväärseid kolmandate osapoolte tööriistu (nt analüütikateenuse pakkujad). Need pakkujad vastavad kehtivatele andmekaitsseadustele.',
    s5Title: '5. Nõusolek',
    s5p1: 'Vajadusel kasutatakse küpsiseid alles pärast teie nõusoleku saamist küpsiste bänneri kaudu.',
    s6Title: '6. Uuendused',
    s6p1: 'Seda küpsiste poliitikat võidakse aeg-ajalt uuendada.',
    s7Title: '7. Kontakt',
    s7p1: 'Küpsistega seotud küsimuste korral',
  },

  // Press page
  press: {
    title: 'Press',
    subtitle: 'Ressursid ajakirjanikele, meediale ja partneritele.',
    description: 'See leht pakub ametlikku teavet, brändivara ja kontaktandmeid Outsprinteriga seotud pressi- ja meediapäringute jaoks.',
    inquiriesTitle: '📰 Pressipäringud',
    inquiriesDesc: 'Meediapäringute, intervjuude või pressikajastuse jaoks palun pöörduge:',
    pressContact: 'Pressikontakt',
    responseTime: 'Püüame vastata pressipäringutele 48 tunni jooksul.',
    brandTitle: '🎨 Brändivara',
    brandDesc: 'Saadaval taotluse alusel:',
    asset1: 'Ettevõtte logo (hele ja tume versioon)',
    asset2: 'Toote ekraanipildid',
    asset3: 'Asutaja fotod',
    asset4: 'Brändijuhised',
    brandNote: 'Palun kasutage ainult kinnitatud vara ja ärge muutke logosid ega värve.',
    overviewTitle: '🏢 Ettevõtte ülevaade',
    overviewP1: 'Outsprinter on B2B täitmisplatvorm, mis aitab ettevõtetel muuta strateegiat mõõdetavateks tulemusteks. Platvorm ühendab KPI halduse, iganädalase sprindi täitmise, reaalajas töölauad ja AI-põhised ülevaated, et aidata meeskondadel püsida joondatud, fokusseeritud ja vastutustundlikuna.',
    overviewP2: 'Outsprinterit kasutavad idufirmad, kasvuettevõtted, suurettevõtted, avaliku sektori asutused ja mittetulundusühingud täitmise kvaliteedi ja otsuste tegemise parandamiseks.',
    topicsTitle: '🗞️ Teemad, mida kommenteerime',
    topic1: 'Täitmine ja tulemuslikkuse juhtimine',
    topic2: 'KPI-põhine juhtimine',
    topic3: 'Iganädalane rütm ja sprindi täitmine',
    topic4: 'AI otsuste tegemisel',
    topic5: 'Kaasaegsed juhtimispraktikad',
    topic6: 'Meeskondade ja organisatsioonide skaleerimine',
    ctaTitle: '📣 Kajastades täitmist, juhtimist või SaaS innovatsiooni?',
    ctaButton: 'Võta ühendust pressimeeskonnaga',
  },

  // Affiliates page
  affiliates: {
    title: 'Partneriprogramm',
    subtitle: 'Teeni, aidates meeskondadel paremini täita.',
    description: 'Outsprinteri partneriprogramm premeerib partnereid, kes tutvustavad ettevõtetele paremat viisi strateegia täitmiseks, KPI-de jälgimiseks ja iganädalaste sprintide läbiviimiseks.',
    whoTitle: '🤝 Kellele programm on mõeldud',
    whoDesc: 'Partneriprogramm on ideaalne:',
    audience1: 'Konsultandid ja koolitajad',
    audience2: 'Osalise ajaga tegevjuhid ja operatsioonijuhid',
    audience3: 'Nõustajad ja mentorid',
    audience4: 'Agentuurid',
    audience5: 'Sisuloojad',
    audience6: 'SaaS kogukonnad',
    whoNote: 'Kui töötate juhtmeeskondadega, on Outsprinter loomulik valik.',
    howTitle: '💰 Kuidas see toimib',
    step1: 'Soovitate ettevõtet Outsprinterile',
    step2: 'Nad alustavad tasulist tellimust',
    step3: 'Teenite korduvat komisjonitasu',
    howNote: 'Lihtne, läbipaistev ja skaleeritav.',
    commTitle: '💸 Komisjonimudel',
    comm1: 'Konkurentsivõimeline korduv komisjonitasu maksva kliendi kohta',
    comm2: 'Pikaajaline tulu jagamine',
    comm3: 'Teenimisele pole ülempiiri',
    comm4: 'Läbipaistev jälgimise töölaud',
    commNote: 'Täpsed komisjonitasu üksikasjad jagatakse pärast kinnitamist.',
    whyTitle: '🧩 Miks partnerlussuhe Outsprinteriga',
    why1: 'Kõrge väärtusega B2B toode',
    why2: 'Selge väärtuspakkumine',
    why3: 'Tugev hoidmispotentsiaal',
    why4: 'Kasvav nõudlus täitmistööriistade järele',
    why5: 'Pühendunud partneritoetus',
    whyNote: 'Aitate ettevõtetel võita — ja saate selle eest tasu.',
    startTitle: '🚀 Alustamine',
    startDesc: 'Kandideerimiseks',
    startStep1: 'Täitke partneriavaldus',
    startStep2: 'Saate kinnituse',
    startStep3: 'Saate oma unikaalse soovituslingi',
    startStep4: 'Alustage Outsprinteri jagamist',
    applyBtn: 'Kandideeri partneriprogrammi',
    ctaTitle: '📣 Aidake ettevõtetel paremini täita — ja kasvake koos meiega.',
    ctaBtn: 'Saa partneriks',
  },

  // Updates page
  updates: {
    title: 'Uuendused',
    badge: 'Toote uuendused',
    subtitle: 'Toote parandused, uued funktsioonid ja pidev innovatsioon — läbipaistvalt jagatud.',
    introP1: 'Outsprinter on ehitatud pidevalt arenevaks täitmisplatvormiks. Tarnime parandusi regulaarselt, et muuta KPI jälgimine, sprindi täitmine ja AI-põhised ülevaated kiiremaks, targemaks ja usaldusväärsemaks.',
    introP2: 'See leht hoiab teid kursis sellega, mis on uut, mis on parandatud ja mis on tulemas.',
    latestTitle: 'Viimased uuendused',
    latestDesc: 'Püsige kursis iga versiooniga. Iga uuendus keskendub tegelikele klientide vajadustele: parem selgus, kiirem täitmine ja sügavamad ülevaated.',
    latest1: 'Täiustatud KPI puu visualiseerimine suurtele organisatsioonidele',
    latest2: 'Kiirem iganädalane sprindi planeerimine AI-toega prioritiseerimisega',
    latest3: 'Parandatud töölaua jõudlus ja reaalajas uuendamine',
    latest4: 'Uued AI ülevaated täitmisriskide ja tulemuslikkuse trendide kohta',
    latest5: 'Laiendatud administraatori kontrollid ettevõtte ja kasutajate haldamiseks',
    latestNote: 'Iga versioon on kavandatud hõõrdumise vähendamiseks ja otsuste tegemise parandamiseks.',
    releaseTitle: 'Versioonimärkmed',
    releaseDesc: 'Selged, struktureeritud ja läbipaistvad. Iga versioonimärkus sisaldab:',
    whatsNew: 'Mis on uut',
    newFeatures: 'Uued funktsioonid',
    newCapabilities: 'Uued võimalused',
    whatsImproved: 'Mis on parandatud',
    perfEnhancements: 'Jõudluse parandused',
    uxImprovements: 'UX parandused',
    bugFixes: 'Veaparandused',
    securityUpdates: 'Turvauuendused',
    stabilityFixes: 'Stabiilsuse parandused',
    aiTitle: 'AI funktsioonide uuendused',
    aiDesc: 'Targem täitmine iga kuu. Outsprinteri AI assistenti koolitatakse ja parandatakse pidevalt.',
    ai1: 'Targemad KPI soovitused ettevõtte suuruse ja valdkonna põhjal',
    ai2: 'Parandatud sprindi prognoosimise täpsus',
    ai3: 'Parem anomaaliate tuvastamine KPI trendides',
    ai4: 'Toimivamad juhtimisülevaated',
    ai5: 'Täiustatud loomuliku keele kokkuvõtted iganädalasteks ülevaadeteks',
    aiGoal: 'Meie eesmärk: vähem käsitsi analüüsi, kindlamad otsused.',
    betaTitle: 'Beetaprogramm',
    betaDesc: 'Saage varajane ligipääs järgmistele funktsioonidele. Liituge Outsprinteri beetaprogrammiga:',
    betaBenefitsTitle: 'Eelised',
    beta1: 'Testige uusi funktsioone enne avalikku väljaannet',
    beta2: 'Mõjutage toote suunda',
    beta3: 'Andke otsest tagasisidet tootemeeskonnale',
    beta4: 'Saage varajane ligipääs täiustatud AI võimalustele',
    betaGetTitle: 'Beetakasutajad saavad',
    betaGet1: 'Varajased funktsioonilipud',
    betaGet2: 'Prioriteetsed tagasisidekanalid',
    betaGet3: 'Varajase kasutaja tunnustus',
    betaNote: '👉 Saadaval Pro, Business ja Enterprise klientidele.',
    perfTitle: 'Jõudluse ja stabiilsuse parandused',
    perfDesc: 'Me investeerime pidevalt:',
    perf1: 'Kiiremate töölaua laadimisaegade jaoks',
    perf2: 'Parandatud süsteemi usaldusväärsusesse',
    perf3: 'Skaleeritavasse infrastruktuuri kasvavatele meeskondadele',
    perf4: 'Täiustatud andmeturbe ja jälgimisesse',
    perfNote: 'Iga uuendust testitakse minimaalse häire ja maksimaalse stabiilsuse tagamiseks.',
    secTitle: 'Turvalisuse ja vastavuse uuendused',
    secDesc: 'Turvalisust käsitletakse põhitootefunktsioonina. Uuendused hõlmavad:',
    sec1: 'Regulaarsed sõltuvuste uuendused',
    sec2: 'Infrastruktuuri tugevdamine',
    sec3: 'Parandatud ligipääsu logimine',
    sec4: 'GDPR ja andmekaitse täiustused',
    secNote: 'Ettevõtte ja vastavusele suunatud kliente teavitatakse asjakohastest muudatustest ennetavalt.',
    roadmapTitle: 'Mis on tulemas',
    roadmapDesc: 'Meie lähiaja teekaart keskendub:',
    road1: 'Täiustatud AI prognoosimine KPI-de jaoks',
    road2: 'Meeskondadeülene sõltuvuste visualiseerimine',
    road3: 'Parandatud juhatuse tasandi aruandlus',
    road4: 'Sügavamad integratsioonid (CRM, HR, BI tööriistad)',
    road5: 'Kohandatud KPI raamistikud valdkonna järgi',
    roadmapNote: 'Me ehitame klientide sisendiga — ja alati täitmise kvaliteeti silmas pidades.',
    ctaTitle: 'Püsi ees platvormiga, mis ei seisa kunagi paigal.',
  },

  // Consulting page
  consulting: {
    title: 'Konsultatsioon',
    badge: 'Nõustamine ja rakendamine',
    heroTitle: 'Strateegia muutmine tegelikuks täitmiseks',
    heroDesc: 'Paljud ettevõtted teavad, mida tahavad saavutada, kuid vaevlevad igapäevase elluviimisega. Meie konsultandid aitavad teil rakendada uusi sisemisi protsesse, mis toimivad igapäevases juhtimises, mitte ainult esitlustes või dokumentides.',
    heroDesc2: 'Aitame teil luua juhtimissüsteemi, mis loob',
    clarity: 'selgust',
    accountability: 'vastutust',
    results: 'mõõdetavaid äritulemusi',
    whatWeDoTitle: 'Mida me teeme',
    whatWeDoDesc: 'Terviklikud konsultatsiooniteenused, mis aitavad teie strateegia muuta selgeteks tegevusteks ja realiseerida selle tulemusrikkalt.',
    service1Title: 'Juhtimise ja KPI raamistiku kujundamine',
    service1Desc: 'Aitame teil defineerida selged eesmärgid (OKR-id, KPI-d) kogu organisatsioonis — ettevõtte tasandist osakondade ja meeskondadeni. Tulemuseks on läbipaistev struktuur, kus igaüks mõistab, kuidas tema töö panustab äritulemustesse.',
    service2Title: 'Protsesside kujundamine ja rakendamine',
    service2Desc: 'Analüüsime teie praeguseid töövooge ning aitame kujundada ja juurutada uusi protsesse, mis:',
    service2b1: 'Parandavad vastutust ja omanditunnet',
    service2b2: 'Vähendavad rutiinset käsitöö mahtu ja ebamäärasust',
    service2b3: 'Loovad distsiplineeritud elluviimise rütmi',
    service3Title: 'Juhtide ja meeskondade võimestamine',
    service3Desc: 'Isegi parimad protsessid ebaõnnestuvad, kui inimesed neid ei kasuta. Töötame tihedalt juhtide ja osakonnajuhtidega, et:',
    service3b1: 'Joondada juhte ümber muutuse olulisuse',
    service3b2: 'Koolitada juhte kasutama KPI-sid igapäevases juhtimises',
    service3b3: 'Juurduda uus süsteem ettevõtte juhtimiskultuuri',
    service4Title: 'Mõõtmine, aruandlus ja pidev parandamine',
    service4Desc: 'Loome selged operatsioonirütmid (nt iganädalased KPI ülevaated), töölauad ja visuaalsed aruanded, mis teevad kohe selgeks:',
    service4b1: 'Mis toimib',
    service4b2: 'Kus tulemuslikkus on rajalt maas',
    service4b3: 'Kus on vaja juhtkonna sekkumist',
    whoTitle: 'Kellele see on mõeldud',
    whoDesc: 'Meie konsultatsioon on mõeldud organisatsioonidele, kes on soovivad rohkem distsipliini ja fookust oma ettevõttesse',
    target1: 'Kasvavad B2B ettevõtted',
    target2: 'Tootmis-, teenus- ja tehnoloogiaettevõtted',
    target3: 'Juhtmeeskonnad, kes otsivad selgust ja kontrolli',
    target4: 'Organisatsioonid, kellel on strateegia paigas, kuid nõrk või aeglane elluviimine',
    approachTitle: 'Meie lähenemine',
    approach1: 'Praktiline, mitte teoreetiline — keskendunud reaalmaailma kasutusele',
    approach2: 'Süsteemipõhine — eesmärgid, protsessid, inimesed ja tööriistad on joondatud',
    approach3: 'Mõõdetav — iga muudatus peab mõjutama tulemusi',
    approach4: 'Koostööle suunatud — rakendame koos teie juhtmeeskonnaga',
    outcomesTitle: 'Tulemused, mida kliendid kogevad',
    outcome1: 'Täielik läbipaistvus kogu organisatsioonis',
    outcome2: 'Selgem vastutus igal tasandil',
    outcome3: 'Kiirem ja parem otsuste tegemine',
    outcome4: 'Tugevam täitmine ja ennustatavad tulemused',
    outcome5: 'KPI-d, mis toimivad tõeliste juhtimistööriistadena, mitte lihtsalt numbritena',
    engageTitle: 'Kuidas koostöö algab',
    engage1: 'Sissejuhatav konsultatsioon',
    engage2: 'Praeguste juhtimispraktikate analüüs',
    engage3: 'Selged soovitused ja tegevuskava',
    engage4: 'Praktiline rakendamine juhtide ja meeskondadega',
    ctaTitle: 'Valmis muutuseks?',
    ctaDesc: 'Arutame, kuidas saame aidata teil luua juhtimissüsteemi, mis annab tõelisi tulemusi.',
    ctaBtn1: 'Broneeri tasuta konsultatsioon',
    ctaBtn2: 'Räägime teie väljakutsetest',
  },

  // Blog page
  blog: {
    seoTitle: 'KPI juhtimise blogi - Ekspertide ülevaated ja parimad praktikad',
    seoDesc: 'Õppige KPI juhtimise, tulemuslikkuse jälgimise ja ärijuhtimise kohta. Ekspertartiklid tõhusate KPI süsteemide loomise, iganädalase jälgimise ja andmepõhise otsuste tegemise kohta.',
    badge: 'KPI juhtimise ülevaated',
    title: 'Outsprinteri blogi',
    subtitle: 'Ekspertide ülevaated KPI juhtimise, tulemuslikkuse jälgimise ja andmepõhiste organisatsioonide loomise kohta.',
    searchPlaceholder: 'Otsi artikleid...',
    allArticles: 'Kõik artiklid',
    noResults: 'Teie otsingule vastavaid artikleid ei leitud.',
    clearFilters: 'Tühjenda filtrid',
    ctaTitle: 'Valmis oma KPI juhtimist muutma?',
    ctaDesc: 'Liituge sadade ettevõtetega, kes kasutavad Outsprinterit tulemuslikkuse iganädalaseks jälgimiseks ja paremate otsuste tegemiseks.',
    ctaBtn: 'Loo konto',
  },

  // Common
  common: {
    loading: 'Laadimine...',
    save: 'Salvesta',
    cancel: 'Tühista',
    delete: 'Kustuta',
    edit: 'Muuda',
    create: 'Loo',
    search: 'Otsi',
    filter: 'Filtreeri',
    noResults: 'Tulemusi ei leitud',
    back: 'Tagasi',
    next: 'Edasi',
    previous: 'Eelmine',
    close: 'Sulge',
    confirm: 'Kinnita',
    yes: 'Jah',
    no: 'Ei',
    and: 'ja',
  },

  // Use Case - Small Startups
  ucStartups: {
    seoTitle: 'Idufirma täitmistarkvara | KPI, ülesannete ja projektide haldus',
    seoDesc: 'Kõik-ühes täitmisplatvorm idufirmadele. Halda KPI-sid, ülesandeid ja projekte ühes süsteemis. Püsi fokusseeritud, joondatud ja kasva kiiremini.',
    badge: 'Väikeettevõtted (1–20 töötajat)',
    heroTitle: 'Ehita fookus varakult. Tegutse kiiresti. Kasva selgusega.',
    heroDesc: 'Idufirmad liiguvad kiiresti — kuid ilma struktuurita muutub kiirus kiiresti kaoseks. Asutajad žongleerivad prioriteetidega, meeskonnad reageerivad planeerimise asemel ja edenemine põhineb sageli intuitsioonil, mitte andmetel. Outsprinter on idufirma täitmisplatvorm, mis ühendab eesmärgid, KPI-d, ülesanded ja projektid ühte süsteemi — aidates varajastel meeskondadel püsida fokusseeritud ja teostada järjepidevalt.',
    challengeTitle: 'Väljakutse idufirmadele',
    challengeIntro: 'Idufirmad võitlevad tavaliselt:',
    ch1: 'Liiga palju ideid, liiga vähe fookust',
    ch2: 'Selge seose puudumine strateegia ja igapäevase töö vahel',
    ch3: 'KPI-sid ei jälgita ega uuendata järjepidevalt',
    ch4: 'Ülesanded laiali tööriistade vahel (Notion, Slack, Excel)',
    ch5: 'Asutajatel puudub reaalajas nähtavus',
    challengeConclusion: 'Selle tulemusena on meeskonnad hõivatud — kuid mitte alati efektiivsed.',
    howTitle: 'Kuidas Outsprinter aitab idufirmadel paremini teostada',
    howIntro: 'Outsprinter loob lihtsa, kuid võimsa täitmissüsteemi:',
    how1: 'Defineeri ettevõtte suund eesmärkide planeerijaga',
    how2: 'Jälgi edenemist reaalajas KPI-dega',
    how3: 'Muuda plaanid tegevuseks ülesannete ja projektide abil',
    how4: 'Kasuta AI ülevaateid tulemuslikkuse parandamiseks',
    howConclusion: 'Täitmine muutub struktureerituks ilma meeskonda aeglustamata.',
    workflowTitle: 'Tüüpiline idufirma töövoog Outsprinteris',
    wf1Title: 'Seadistamine',
    wf1a: 'Asutaja defineerib ettevõtte eesmärgid ja KPI-d',
    wf1b: 'Loob algsed projektid (kasv, toode, müük)',
    wf1c: 'Määrab vastutuse meeskonnas',
    wf2Title: 'Igapäevane täitmine',
    wf2a: 'Ülesanded jälgitud tähtaegade ja prioriteetidega',
    wf2b: 'Alamülesanded keeruka töö jaotamiseks',
    wf2c: 'Korduvad ülesanded rutiinide jaoks (aruanded, standupid, ops)',
    wf3Title: 'Iganädalane ülevaade',
    wf3a: 'KPI-d uuendatud',
    wf3b: 'Töölaud näitab ettevõtte tulemuslikkust',
    wf3c: 'AI toob esile riskid ja võimalused',
    featuresTitle: 'Põhifunktsioonid idufirmadele',
    feat1Title: 'KPI haldus',
    feat1a: 'Jälgi põhimõõdikuid ühes süsteemis',
    feat1b: 'Visuaalsed tulemuslikkuse indikaatorid',
    feat1c: 'Iganädalane edenemise jälgimine',
    feat2Title: 'Ülesannete haldus',
    feat2a: 'Määra ülesanded selge vastutusega',
    feat2b: 'Prioriteedid, tähtajad, alamülesanded',
    feat2c: 'Korduvad töövood',
    feat3Title: 'Projektihaldus',
    feat3a: 'Struktureeri töö algatusteks',
    feat3b: 'Jälgi edenemist ja vastutust',
    feat4Title: 'Töölauad',
    feat4a: 'Reaalajas ettevõtte ülevaade',
    feat4b: 'Kohene nähtavus tulemuslikkusesse',
    feat5Title: 'AI assistent',
    feat5a: 'KPI soovitused',
    feat5b: 'Tulemuslikkuse ülevaated',
    feat5c: 'Riskide tuvastamine',
    resultsTitle: 'Mõõdetavad tulemused',
    resultsIntro: 'Outsprinterit kasutavad idufirmad saavutavad tavaliselt:',
    res1: 'Kiirem täitmine',
    res2: 'Selgemad prioriteedid',
    res3: 'Parem meeskonna joondatus',
    res4: 'Vähenenud kaos',
    res5: 'Andmepõhised otsused',
    whyTitle: 'Miks Outsprinter sobib idufirmadele',
    why1: 'Kiire seadistamine (alla 30 minuti)',
    why2: 'Ei mingeid keerulisi konfiguratsioone',
    why3: 'Ühendab mitu tööriista üheks',
    why4: 'Skaleerub koos ettevõttega',
    ctaTitle: 'Ehita täitmisdistsipliin algusest peale.',
  },

  // Use Case - SMB
  ucSMB: {
    seoTitle: 'Täitmistarkvara kasvavatele ettevõtetele | KPI ja projektide haldus',
    seoDesc: 'Joonda meeskonnad, jälgi KPI-sid ja halda projekte ühes süsteemis. Outsprinter aitab VKE-del skaleerida täitmist ilma kontrolli kaotamata.',
    badge: 'Väikesed ja keskmised ettevõtted (21–200 töötajat)',
    heroTitle: 'Loo joondatus meeskondade vahel. Teosta mastaapselt. Püsi kontrolli all.',
    heroDesc: 'Kui ettevõtted kasvavad, muutub täitmine raskemaks — mitte lihtsamaks. Rohkem meeskondi, rohkem juhte ja rohkem prioriteete loovad ebakõla ja aeglustavad otsustamist. Outsprinter on täitmisjuhtimise platvorm kasvavatele ettevõtetele, mis ühendab KPI-d, ülesanded ja projektid ühte ühtsesse süsteemi.',
    challengeTitle: 'Väljakutse kasvavatele ettevõtetele',
    challengeIntro: 'Kasvavad ettevõtted võitlevad tavaliselt:',
    ch1: 'Meeskonnad töötavad eraldatult',
    ch2: 'Osakonna eesmärgid pole joondatud ettevõtte strateegiaga',
    ch3: 'KPI-sid jälgitakse ebaühtlaselt või liiga hilja',
    ch4: 'Töö toimub mitmes tööriistas',
    ch5: 'Juhtkond reageerib juhtimise asemel',
    challengeConclusion: 'Kasv toob esile täitmise lüngad.',
    howTitle: 'Kuidas Outsprinter toob struktuuri ilma aeglustamata',
    howIntro: 'Outsprinter toob struktuuri sinna, kus vaja — ja paindlikkust sinna, kus see loeb. Outsprinteriga saavad VKE-d:',
    how1: 'Joondada ettevõtte eesmärgid osakonna KPI-dega',
    how2: 'Ühendada KPI-d otse projektide ja ülesannetega',
    how3: 'Jälgida täitmist reaalajas',
    how4: 'Tuvastada riske varakult AI abil',
    how5: 'Säilitada kiirust skaleerimisel',
    howConclusion: '',
    workflowTitle: 'Tüüpiline VKE töövoog Outsprinteris',
    wf1Title: 'Ettevõtte seadistamine',
    wf1a: 'Juhtkond defineerib ettevõtte tasandi KPI-d',
    wf1b: 'Osakonnad loovad joondatud KPI-d',
    wf1c: 'Projektid loodud võtmealgatuste edendamiseks',
    wf1d: 'Vastutus määratud kogu organisatsioonis',
    wf2Title: 'Täitmine',
    wf2a: 'Meeskonnad haldavad ülesandeid ja projekte',
    wf2b: 'Korduvad protsessid jälgitud (aruanded, operatsioonid)',
    wf2c: 'Töö nähtav osakondade üleselt',
    wf3Title: 'Juhtkonna ülevaade',
    wf3a: 'Tegevjuht vaatab ettevõtte töölauda',
    wf3b: 'Punased KPI-d käivitavad fokusseeritud arutelud',
    wf3c: 'AI toob esile riskid ja trendid',
    featuresTitle: 'Põhifunktsioonid VKE-dele',
    feat1Title: 'KPI puu',
    feat1a: 'Ettevõte → osakond → KPI struktuur',
    feat1b: 'Täielik joondatuse nähtavus',
    feat2Title: 'Ülesannete haldus',
    feat2a: 'Selge vastutus meeskondade üleselt',
    feat2b: 'Prioriteedid, tähtajad, alamülesanded',
    feat3Title: 'Projektihaldus',
    feat3a: 'Jälgi algatusi',
    feat3b: 'Monitoori töökoormust ja edenemist',
    feat4Title: 'Töölauad',
    feat4a: 'Ettevõtteülene ülevaade',
    feat4b: 'Osakonna tulemuslikkuse ülevaated',
    feat5Title: 'AI assistent',
    feat5a: 'Riskide tuvastamine',
    feat5b: 'Tulemuslikkuse ülevaated',
    resultsTitle: 'Mõõdetavad tulemused',
    resultsIntro: 'Ettevõtted näevad tavaliselt:',
    res1: 'Tugevam meeskondadeülene joondatus',
    res2: 'Kiiremad juhtimisotsused',
    res3: 'Vähem üllatusi tulemuslikkuses',
    res4: 'Selge vastutus tulemuste eest',
    res5: 'Kõrgem täitmise järjepidevus',
    whyTitle: 'Miks Outsprinter sobib kasvavatele organisatsioonidele',
    why1: 'Skaleerub ilma uuesti juurutamiseta',
    why2: 'Töötab mitme meeskonnaga',
    why3: 'Ühendab KPI-d, ülesanded ja projektid',
    why4: 'Võimaldab struktureeritud täitmist',
    ctaTitle: 'Skaleeri täitmist selgust kaotamata.',
  },

  // Use Case - Enterprise
  ucEnterprise: {
    seoTitle: 'Ettevõtte täitmisplatvorm | KPI, projektide ja ülesannete haldus',
    seoDesc: 'Ettevõtte täitmisplatvorm strateegia, KPI-de ja projektide joondamiseks. Saa reaalajas nähtavus ja kontroll kogu organisatsioonis.',
    badge: 'Suurettevõtted',
    heroTitle: 'Too selgus keerukusesse. Joonda täitmine kogu organisatsioonis.',
    heroDesc: 'Suured organisatsioonid ei võitle strateegiaga — nad võitlevad täitmisega mastaapselt. Mitmed äriüksused, keerulised struktuurid ja killustatud süsteemid loovad nähtavuse puudumise ja aeglustavad otsustamist. Outsprinter on ettevõtte täitmisplatvorm, mis ühendab strateegia, KPI-d, projektid ja ülesanded ühte läbipaistvasse süsteemi.',
    challengeTitle: 'Väljakutse suurettevõtetele',
    challengeIntro: 'Suurettevõtted seisavad sageli silmitsi:',
    ch1: 'Ühendamata äriüksused',
    ch2: 'Viivitatud ja filtreeritud aruandlus',
    ch3: 'Mitmed tööriistad ja killustatud andmed',
    ch4: 'Aeglane reageerimine probleemidele',
    ch5: 'Reaalajas nähtavuse puudumine',
    challengeConclusion: 'Täitmine muutub keeruliseks ja läbipaistmatuks.',
    howTitle: 'Kuidas Outsprinter lahendab ettevõtte täitmise',
    howIntro: 'Outsprinter pakub ühtset täitmissüsteemi:',
    how1: 'Joonda strateegia mõõdetavate KPI-dega',
    how2: 'Ühenda KPI-d projektide ja ülesannetega',
    how3: 'Paku juhtkonnale reaalajas töölaudu',
    how4: 'Standardiseeri täitmine osakondade üleselt',
    howConclusion: '',
    workflowTitle: 'Tüüpiline ettevõtte töövoog',
    wf1Title: 'Strateegiline kiht',
    wf1a: 'Defineeri ettevõtte tasandi KPI-d',
    wf1b: 'Joonda äriüksused',
    wf1c: 'Sea pikaajalised eesmärgid',
    wf2Title: 'Täitmise kiht',
    wf2a: 'Halda projekte osakondade üleselt',
    wf2b: 'Määra ülesanded vastutusega',
    wf2c: 'Jälgi edenemist pidevalt',
    wf3Title: 'Juhtkonna kiht',
    wf3a: 'Juhtide töölauad',
    wf3b: 'Reaalajas tulemuslikkuse ülevaated',
    wf3c: 'AI-põhine riskide tuvastamine',
    featuresTitle: 'Põhifunktsioonid suurettevõtetele',
    feat1Title: 'KPI raamistik',
    feat1a: 'Mitmetasandiline KPI struktuur',
    feat1b: 'Üksustevaheline nähtavus',
    feat2Title: 'Projektihaldus',
    feat2a: 'Jälgi suuri algatusi',
    feat2b: 'Monitoori tulemuslikkust',
    feat3Title: 'Ülesannete haldus',
    feat3a: 'Organisatsiooniülene täitmise jälgimine',
    feat3b: 'Selge vastutus',
    feat4Title: 'Töölauad',
    feat4a: 'Juhatuse tasandi nähtavus',
    feat4b: 'Reaalajas andmed',
    feat5Title: 'AI assistent',
    feat5a: 'Ennustavad ülevaated',
    feat5b: 'Riskide tuvastamine',
    resultsTitle: 'Mõõdetavad tulemused',
    resultsIntro: 'Organisatsioonid saavutavad tavaliselt:',
    res1: 'Kiirem otsustamine',
    res2: 'Suurenenud läbipaistvus',
    res3: 'Parem joondatus',
    res4: 'Vähenenud aruandluse halduskoormus',
    res5: 'Tugevam täitmise kontroll',
    whyTitle: 'Miks Outsprinter sobib suurettevõtetele',
    why1: 'Toetab keerulisi struktuure',
    why2: 'Skaleerub osakondade üleselt',
    why3: 'Paindlik, kuid struktureeritud',
    why4: 'Ettevõtte tasandi nähtavus',
    ctaTitle: 'Too selgus ettevõtte täitmisse.',
  },

  // Use Case - IT Teams
  ucIT: {
    seoTitle: 'IT täitmistarkvara | ülesannete, projektide ja KPI haldus',
    seoDesc: 'Joonda IT töö ärieesmärkidega. Halda ülesandeid, projekte ja KPI-sid ühes süsteemis. Paranda tarnet, nähtavust ja tulemuslikkust.',
    badge: 'IT meeskonnad',
    heroTitle: 'Muuda tehniline töö mõõdetavaks ärimõjuks.',
    heroDesc: 'IT meeskonnad tarnivad kriitilist tööd — kuid juhtkond näeb sageli vaeva tegeliku mõju nägemisega. Ülesandeid, pileteid ja projekte jälgitakse, kuid harva ühendatakse äritulemustega. Outsprinter on IT täitmisplatvorm, mis ühendab tehnilise töö mõõdetavate tulemustega KPI-de, projektide ja struktureeritud ülesannete halduse kaudu.',
    challengeTitle: 'Väljakutse IT meeskondadele',
    challengeIntro: 'IT meeskonnad seisavad sageli silmitsi:',
    ch1: 'Liiga palju ülesandeid ja konkureerivaid prioriteete',
    ch2: 'Töö pole ühendatud äritulemustega',
    ch3: 'Piiratud nähtavus juhtkonnale',
    ch4: 'Ülekoormatud meeskonnad ja ebaühtlane töökoormus',
    ch5: 'Pidev tulekahjude kustutamine plaanilise täitmise asemel',
    challengeConclusion: '',
    howTitle: 'Kuidas Outsprinter parandab IT täitmist',
    howIntro: 'Outsprinteriga saavad IT meeskonnad:',
    how1: 'Defineerida tehnilised KPI-d (tööaeg, tarne kiirus, usaldusväärsus)',
    how2: 'Ühendada projektid ärieesmärkidega',
    how3: 'Hallata ülesandeid selge vastutuse ja tähtaegadega',
    how4: 'Tasakaalustada töökoormust meeskonnas',
    how5: 'Saada nähtavus tarnesse ja tulemuslikkusesse',
    howConclusion: '',
    workflowTitle: 'Tüüpiline IT töövoog Outsprinteris',
    wf1Title: 'Seadistamine',
    wf1a: 'Defineeri tehnilised KPI-d',
    wf1b: 'Loo projektid (funktsioonid, infrastruktuur, parandused)',
    wf1c: 'Määra vastutus',
    wf2Title: 'Täitmine',
    wf2a: 'Ülesanded jälgitud alamülesannete ja prioriteetidega',
    wf2b: 'Korduvad ülesanded hoolduse ja operatsioonide jaoks',
    wf2c: 'Projektide edenemise monitooring',
    wf3Title: 'Juhtkonna vaade',
    wf3a: 'Töölauad näitavad tarne tervist',
    wf3b: 'AI toob esile riskid ja pudelikaelad',
    featuresTitle: 'Põhifunktsioonid IT meeskondadele',
    feat1Title: 'KPI haldus',
    feat1a: 'Jälgi tööaega, tulemuslikkust, tarne mõõdikuid',
    feat2Title: 'Ülesannete haldus',
    feat2a: 'Struktureeritud ülesannete täitmine',
    feat2b: 'Alamülesanded ja korduvad tööd',
    feat3Title: 'Projektihaldus',
    feat3a: 'Funktsioonide ja infrastruktuuri jälgimine',
    feat3b: 'Edenemise nähtavus',
    feat4Title: 'Töölauad',
    feat4a: 'Tarne ja tulemuslikkuse ülevaade',
    feat5Title: 'AI assistent',
    feat5a: 'Pudelikaela tuvastamine',
    feat5b: 'Tulemuslikkuse ülevaated',
    resultsTitle: 'Mõõdetavad tulemused',
    resultsIntro: 'IT meeskonnad saavutavad tavaliselt:',
    res1: 'Parem prioriseerimine',
    res2: 'Vähenenud ülekoormus',
    res3: 'Paranenud tarne ennustatavus',
    res4: 'Selge nähtavus juhtkonnale',
    whyTitle: '',
    ctaTitle: 'Joonda tehnoloogia tulemustega.',
  },

  // Use Case - E-commerce
  ucEcom: {
    seoTitle: 'E-kaubanduse KPI ja tulemuslikkuse haldus tarkvara',
    seoDesc: 'Jälgi tulu, konversiooni ja turunduse KPI-sid, hallates samal ajal ülesandeid ja kampaaniaid. Skaleeri oma e-kaubandust selgusega.',
    badge: 'E-kaubandus',
    heroTitle: 'Liigu kiiremini. Optimeeri tulemuslikkust. Skaleeri efektiivselt.',
    heroDesc: 'E-kaubanduse ettevõtted tegutsevad kiiresti muutuvas keskkonnas, kus tulemuslikkus muutub igapäevaselt. Ilma selge süsteemita viibivad otsused ja kasv muutub ettearvamatuks. Outsprinter on e-kaubanduse täitmisplatvorm, mis ühendab tulemuslikkuse mõõdikud, kampaaniad ja täitmise ühte süsteemi.',
    challengeTitle: 'Väljakutse',
    challengeIntro: 'E-kaubanduse ettevõtted seisavad tavaliselt silmitsi:',
    ch1: 'Andmed laiali tööriistade vahel (reklaamid, analüütika, CRM)',
    ch2: 'Ühtse tulemuslikkuse ülevaate puudumine',
    ch3: 'Turundus ja operatsioonid pole joondatud',
    ch4: 'Aeglane reageerimine tulemuslikkuse muutustele',
    howTitle: 'Kuidas Outsprinter aitab',
    howIntro: 'Outsprinteriga saavad e-kaubanduse meeskonnad:',
    how1: 'Jälgida KPI-sid (konversioonimäär, tulu, CAC, AOV)',
    how2: 'Hallata kampaaniaid projektidena',
    how3: 'Määrata ülesandeid turunduse ja operatsioonide vahel',
    how4: 'Monitoorida tulemuslikkust reaalajas',
    workflowTitle: 'Tüüpiline töövoog',
    wf1Title: 'Seadistamine',
    wf1a: 'Defineeri kasvu KPI-d',
    wf1b: 'Loo turundus- ja operatsiooniprojektid',
    wf2Title: 'Täitmine',
    wf2a: 'Ülesanded kampaaniate ja optimeerimiste jaoks',
    wf2b: 'Korduvad ülesanded aruandluse jaoks',
    wf3Title: 'Monitooring',
    wf3a: 'Reaalajas töölauad',
    wf3b: 'AI toob esile tulemuslikkuse langused',
    featuresTitle: 'Põhifunktsioonid',
    feat1: 'KPI jälgimine kasvu mõõdikute jaoks',
    feat2: 'Projektihaldus kampaaniate jaoks',
    feat3: 'Ülesannete haldus täitmise jaoks',
    feat4: 'Reaalajas töölauad',
    feat5: 'AI ülevaated',
    resultsTitle: 'Tulemused',
    res1: 'Kiiremad optimeerimistsüklid',
    res2: 'Paremad otsused',
    res3: 'Suurenenud kasvu ennustatavus',
    ctaTitle: 'Skaleeri oma e-kaubandust selgusega.',
  },

  // Use Case - SaaS
  ucSaaS: {
    seoTitle: 'SaaS KPI jälgimine ja täitmisplatvorm',
    seoDesc: 'Jälgi ARR-i, churn-i ja kasvu KPI-sid, hallates samal ajal projekte ja ülesandeid. Joonda toote, müügi ja turunduse meeskonnad.',
    badge: 'SaaS ettevõtted',
    heroTitle: 'Skaleeri andmepõhise täitmisega.',
    heroDesc: 'SaaS ettevõtted sõltuvad tugevalt mõõdikutest — kuid need mõõdikud on sageli lahti ühendatud igapäevasest täitmisest. Outsprinter on SaaS täitmisplatvorm, mis ühendab kasvu KPI-d projektide ja ülesannetega.',
    challengeTitle: 'Väljakutse',
    challengeIntro: 'SaaS ettevõtted seisavad tavaliselt silmitsi:',
    ch1: 'Mõõdikuid jälgitakse, kuid nende alusel ei tegutseta',
    ch2: 'Ebakõla toote, müügi ja turunduse vahel',
    ch3: 'Aeglased iteratsioonitsüklid',
    ch4: 'Täitmise nähtavuse puudumine',
    howTitle: 'Kuidas Outsprinter aitab',
    howIntro: 'Outsprinteriga saavad SaaS meeskonnad:',
    how1: 'Jälgida põhilisi SaaS mõõdikuid (ARR, churn, LTV)',
    how2: 'Hallata kasvu algatusi projektidena',
    how3: 'Joondada meeskondi jagatud KPI-de kaudu',
    how4: 'Monitoorida täitmist reaalajas',
    workflowTitle: 'Tüüpiline töövoog',
    wf1: 'Defineeri kasvu KPI-d',
    wf2: 'Loo projektid (toode, kasv, müük)',
    wf3: 'Määra ülesanded',
    wf4: 'Jälgi tulemusi',
    resultsTitle: 'Tulemused',
    res1: 'Ennustatav kasv',
    res2: 'Kiirem iteratsioon',
    res3: 'Parem joondatus',
    ctaTitle: 'Skaleeri oma SaaS-i täitmise selgusega.',
  },

  // Use Case - Sales
  ucSales: {
    seoTitle: 'Müügi KPI ja müügitoru haldustarkvara',
    seoDesc: 'Jälgi müügitoru, tulu ja müügi KPI-sid, hallates samal ajal ülesandeid. Paranda prognoosimist ja sulge rohkem tehinguid.',
    badge: 'Müügimeeskonnad',
    heroTitle: 'Muuda tegevus ennustatavaks tuluks.',
    heroDesc: 'Müügimeeskonnad on aktiivsed — kuid tegevus üksi ei garanteeri tulemusi. Ilma nähtavuse ja struktuurita muutub prognoosimine ebausaldusväärseks. Outsprinter on müügi täitmisplatvorm, mis ühendab KPI-d, müügitoru töö ja ülesanded.',
    challengeTitle: 'Väljakutse',
    challengeIntro: 'Müügimeeskonnad seisavad tavaliselt silmitsi:',
    ch1: 'Kehv müügitoru nähtavus',
    ch2: 'Ebatäpne prognoosimine',
    ch3: 'Tegevus ilma selgete tulemusteta',
    ch4: 'Joondatuse puudumine ettevõtte eesmärkidega',
    howTitle: 'Kuidas Outsprinter aitab',
    howIntro: 'Outsprinteriga saavad müügimeeskonnad:',
    how1: 'Jälgida müügi KPI-sid (müügitoru, konversioon, tulu)',
    how2: 'Hallata tehingute täitmist ülesannetena',
    how3: 'Joondada müük ettevõtte eesmärkidega',
    how4: 'Monitoorida tulemuslikkust reaalajas',
    workflowTitle: 'Tüüpiline töövoog',
    wf1: 'Defineeri tulu KPI-d',
    wf2: 'Jälgi müügitoru tulemuslikkust',
    wf3: 'Määra tehingutega seotud ülesanded',
    wf4: 'Monitoori tulemusi',
    resultsTitle: 'Tulemused',
    res1: 'Parem prognoosimine',
    res2: 'Kõrgemad konversioonimäärad',
    res3: 'Selged prioriteedid',
    ctaTitle: 'Muuda müügitäitmine ennustatavaks.',
  },

  // Use Case - Operations
  ucOps: {
    seoTitle: 'Operatsioonide haldustarkvara KPI-de ja ülesannetega',
    seoDesc: 'Halda operatiivseid KPI-sid, korduvaid ülesandeid ja parandusprojekte. Paranda efektiivsust ja usaldusväärsust.',
    badge: 'Operatsioonide meeskonnad',
    heroTitle: 'Juhi operatsioone selguse ja järjepidevusega.',
    heroDesc: 'Operatsioonide meeskonnad tagavad, et kõik sujuks — kuid neil puuduvad sageli struktureeritud süsteemid ja nähtavus. Outsprinter on operatsioonide täitmisplatvorm, mis ühendab KPI-d, ülesanded ja projektid.',
    challengeTitle: 'Väljakutse',
    challengeIntro: 'Operatsioonide meeskonnad seisavad sageli silmitsi:',
    ch1: 'Käsitsi protsessid',
    ch2: 'Nähtavuse puudumine',
    ch3: 'Reaktiivsed operatsioonid',
    ch4: 'Ebaühtlane täitmine',
    howTitle: 'Kuidas Outsprinter aitab',
    howIntro: 'Outsprinteriga saavad operatsioonide meeskonnad:',
    how1: 'Jälgida operatiivseid KPI-sid',
    how2: 'Hallata korduvaid ülesandeid',
    how3: 'Parandada protsesse projektide kaudu',
    how4: 'Saada reaalajas nähtavus',
    workflowTitle: 'Tüüpiline töövoog',
    wf1: 'Defineeri operatiivsed KPI-d',
    wf2: 'Loo korduvad ülesanded',
    wf3: 'Halda parandusprojekte',
    resultsTitle: 'Tulemused',
    res1: 'Suurenenud efektiivsus',
    res2: 'Parem usaldusväärsus',
    res3: 'Pidev parandamine',
    ctaTitle: 'Juhi operatsioone kindlustundega.',
  },

  // Use Case - Management Board
  ucBoard: {
    seoTitle: 'Juhtide töölaud ja KPI haldusplatvorm',
    seoDesc: 'Reaalajas töölauad juhtidele. Jälgi KPI-sid, projekte ja täitmist kogu ettevõttes.',
    badge: 'Juhatus',
    heroTitle: 'Tee otsuseid reaalsete andmete põhjal — mitte aruannete.',
    heroDesc: 'Juhid tuginevad sageli viivitatud, filtreeritud aruannetele. See aeglustab otsustamist ja vähendab nähtavust. Outsprinter pakub reaalajas juhtide töölaudu, mis on ühendatud täitmisega.',
    challengeTitle: 'Väljakutse',
    challengeIntro: 'Juhid seisavad sageli silmitsi:',
    ch1: 'Viivitatud aruandlus',
    ch2: 'Läbipaistvuse puudumine',
    ch3: 'Aeglased otsused',
    howTitle: 'Kuidas Outsprinter aitab',
    howIntro: 'Outsprinteriga saavad juhid:',
    how1: 'Reaalajas KPI töölauad',
    how2: 'Täielik nähtavus täitmisse',
    how3: 'AI ülevaated kiiremate otsuste jaoks',
    resultsTitle: 'Tulemused',
    res1: 'Kiiremad otsused',
    res2: 'Parem valitsemine',
    res3: 'Suurenenud selgus',
    ctaTitle: 'Juhi andmetega. Valitse kindlustundega.',
  },

  // Use Case - Public Institutions
  ucPublic: {
    seoTitle: 'Avaliku sektori KPI ja tulemuslikkuse haldustarkvara',
    seoDesc: 'Jälgi avaliku sektori KPI-sid ja projekte läbipaistvalt. Paranda vastutust ja aruandlust.',
    badge: 'Avalik sektor',
    heroTitle: 'Suurenda läbipaistvust ja vastutust.',
    heroDesc: 'Avalikud organisatsioonid vajavad selget aruandlust ja mõõdetavaid tulemusi. Outsprinter pakub struktureeritud süsteemi tulemuslikkuse jälgimiseks.',
    challengeTitle: 'Väljakutse',
    challengeIntro: 'Avalikud organisatsioonid seisavad sageli silmitsi:',
    ch1: 'Keeruline aruandlus',
    ch2: 'Madal läbipaistvus',
    ch3: 'Aeglased protsessid',
    howTitle: 'Kuidas Outsprinter aitab',
    howIntro: 'Outsprinteriga saavad avalikud organisatsioonid:',
    how1: 'KPI jälgimine',
    how2: 'Projektide nähtavus',
    how3: 'Selge vastutus',
    resultsTitle: 'Tulemused',
    res1: 'Parem vastutus',
    res2: 'Paranenud aruandlus',
    res3: 'Läbipaistev tulemuslikkus',
    ctaTitle: 'Too selgus avalikku teenistusse.',
  },

  // Use Case - Nonprofits
  ucNonprofit: {
    seoTitle: 'MTÜ KPI ja mõju jälgimise tarkvara',
    seoDesc: 'Jälgi mõju, halda projekte ja paranda läbipaistvust. Aita oma MTÜ-l pakkuda mõõdetavaid tulemusi.',
    badge: 'Mittetulundusühingud',
    heroTitle: 'Mõõda mõju. Ehita usaldust. Paku tulemusi.',
    heroDesc: 'MTÜ-d peavad demonstreerima mõju, hallates samal ajal piiratud ressursse. Outsprinter aitab jälgida tulemusi ja joondada täitmist.',
    challengeTitle: 'Väljakutse',
    challengeIntro: 'MTÜ-d seisavad sageli silmitsi:',
    ch1: 'Raskesti mõõdetav mõju',
    ch2: 'Annetajate ootused',
    ch3: 'Käsitsi aruandlus',
    howTitle: 'Kuidas Outsprinter aitab',
    howIntro: 'Outsprinteriga saavad MTÜ-d:',
    how1: 'Jälgida mõju KPI-sid',
    how2: 'Hallata programme projektidena',
    how3: 'Pakkuda läbipaistvaid töölaudu',
    resultsTitle: 'Tulemused',
    res1: 'Selge mõju',
    res2: 'Parem usaldus',
    res3: 'Paranenud fookus',
    ctaTitle: 'Paku rohkem mõju selgusega.',
  },

  // Use Case - Consulting & Agencies
  ucConsulting: {
    seoTitle: 'Agentuuri projektide ja KPI haldustarkvara',
    seoDesc: 'Halda klientide projekte, jälgi KPI-sid ja paranda tarnet. Üks süsteem konsultatsioonimeeskondadele ja agentuuridele.',
    badge: 'Konsultatsioon ja agentuurid',
    heroTitle: 'Tarni klientide tulemusi selguse ja kontrolliga.',
    heroDesc: 'Agentuurid haldavad mitut klienti, projekti ja tähtaega — sageli mitme tööriista vahel. Outsprinter toob kõik ühte süsteemi.',
    challengeTitle: 'Väljakutse',
    challengeIntro: 'Agentuurid seisavad sageli silmitsi:',
    ch1: 'Mitu klienti',
    ch2: 'Ülesannete ülekoormus',
    ch3: 'Nähtavuse puudumine',
    howTitle: 'Kuidas Outsprinter aitab',
    howIntro: 'Outsprinteriga saavad agentuurid:',
    how1: 'Projektipõhine struktuur kliendi kohta',
    how2: 'KPI jälgimine tulemuslikkuse jaoks',
    how3: 'Ülesannete haldus täitmise jaoks',
    resultsTitle: 'Tulemused',
    res1: 'Parem tarne',
    res2: 'Rahulolevamad kliendid',
    res3: 'Ennustatavad tulemused',
    ctaTitle: 'Tarni klientide tulemusi kindlustundega.',
  },

  // Use Case - Manufacturing
  ucManuf: {
    seoTitle: 'Tootmise ja tööstuse KPI tarkvara',
    seoDesc: 'Jälgi tootmise KPI-sid, halda operatiivseid ülesandeid ja juhi parendusprojekte. Saa reaalajas ülevaade kogu tootmistegevusest.',
    badge: 'Tootmine ja töötlev tööstus',
    heroTitle: 'Suurenda efektiivsust. Vähenda raiskamist. Saavuta täielik kontroll.',
    heroDesc: 'Tootmisettevõtted tegutsevad keskkondades, kus väikesed ebatõhusused muutuvad kiiresti suureks kuluks. Tootmise viivitused, kvaliteediprobleemid ja osakondade vaheline ebaühtlus tulenevad sageli ühest põhiprobleemist: reaalajas nähtavuse ja struktureeritud täitmise puudumine. Outsprinter annab tootmisettevõtetele ühtse süsteemi KPI-de, projektide ja igapäevaste operatiivsete ülesannete haldamiseks — tagades, et iga osa organisatsioonist on joondatud ja pidevalt paranemas.',
    challengeTitle: 'Tootmisettevõtete väljakutse',
    challengeIntro: 'Tootmisorganisatsioonid võitlevad tavaliselt:',
    ch1: 'KPI-d jälgitud tabelites või lahtiühendatud süsteemides',
    ch2: 'Viivitused ja probleemid avastatakse liiga hilja',
    ch3: 'Kehv nähtavus tootmisliinide, vahetuste või tehaste üleselt',
    ch4: 'Liiga palju mõõdikuid ilma selge fookuseta',
    ch5: 'Meeskonnad reageerivad probleemidele nende ennetamise asemel',
    challengeConclusion: 'Keerukuse kasvades väheneb kontroll.',
    howTitle: 'Kuidas Outsprinter toob struktuuri tootmisse',
    howIntro: 'Outsprinter ühendab tootmise tulemuslikkuse igapäevase täitmisega. Outsprinteriga saavad tootmisettevõtted:',
    how1: 'Defineerida ja jälgida tootmise KPI-sid (OEE, seisakuaeg, praagi määr, läbilaskevõime)',
    how2: 'Ühendada KPI-d otse projektide ja ülesannetega',
    how3: 'Hallata parendusalgatusi struktureeritud projektidena',
    how4: 'Määrata selge vastutus tootmise, hoolduse ja kvaliteedi meeskondades',
    how5: 'Tuvastada probleeme varakult reaalajas töölaudade ja hoiatustega',
    howConclusion: 'Täitmine muutub mõõdetavaks, nähtavaks ja proaktiivseks.',
    workflowTitle: 'Tüüpiline tootmise töövoog Outsprinteris',
    wf1Title: 'Tootmise seadistamine',
    wf1a: 'Juhtkond defineerib ettevõtte tasandi KPI-d',
    wf1b: 'Tehased ja osakonnad defineerivad operatiivsed KPI-d',
    wf1c: 'KPI vastutajad määratud liini, vahetuse või funktsiooni kaupa',
    wf2Title: 'Igapäevane ja iganädalane täitmine',
    wf2a: 'Meeskonnad haldavad ülesandeid (hooldus, kvaliteedikontrollid, parendused)',
    wf2b: 'Korduvad ülesanded tagavad operatiivsed rutiinid (kontrollid, aruanded)',
    wf2c: 'Projektid jälgivad parendusalgatusi (efektiivsus, kulude vähendamine)',
    wf2d: 'KPI-d uuendatakse iganädalaselt (või integreeritakse impordi kaudu)',
    wf3Title: 'Juhtimise ülevaade',
    wf3a: 'Juhtkond jälgib töölaudu tehaste üleselt',
    wf3b: 'Probleemid (punased KPI-d) käivitavad kohese tegutsemise',
    wf3c: 'AI toob esile anomaaliad ja tulemuslikkuse langused',
    featuresTitle: 'Põhifunktsioonid tootmisettevõtetele',
    feat1Title: 'KPI haldus',
    feat1a: 'Jälgi tootmise KPI-sid ühes süsteemis',
    feat1b: 'Automaatsed staatuse indikaatorid (roheline / kollane / punane)',
    feat1c: 'Trendi nähtavus ajas',
    feat2Title: 'Ülesannete haldus',
    feat2a: 'Määra operatiivsed ülesanded tähtaegade ja prioriteetidega',
    feat2b: 'Alamülesanded keerukate töövoogude jaoks',
    feat2c: 'Korduvad ülesanded rutiinsete operatsioonide jaoks',
    feat3Title: 'Projektihaldus',
    feat3a: 'Halda parendusalgatusi projektidena',
    feat3b: 'Jälgi edenemist ja projekti tervist',
    feat3c: 'Monitoori töökoormust ja ressursside jaotamist',
    feat4Title: 'Töölauad',
    feat4a: 'Reaalajas tootmise tulemuslikkuse ülevaade',
    feat4b: 'Osakondade ülene nähtavus',
    feat4c: 'Tehase ja ettevõtte tasandi ülevaated',
    feat5Title: 'Nutikas AI assistent',
    feat5a: 'Tuvasta tulemuslikkuse anomaaliaid',
    feat5b: 'Identifitseeri pudelikaelad ja riskid',
    feat5c: 'Soovita parendusvaldkondi',
    resultsTitle: 'Mõõdetavad tulemused tootmisele',
    resultsIntro: 'Outsprinterit kasutavad tootmisettevõtted saavutavad tavaliselt:',
    res1: 'Kõrgem tootmise efektiivsus',
    res2: 'Vähenenud seisakuaeg ja raiskamine',
    res3: 'Kiirem probleemide tuvastamine',
    res4: 'Parem koordinatsioon meeskondade vahel',
    res5: 'Prognoositavam väljund ja tarnimine',
    resultsConclusion: 'Outsprinter aitab tootmismeeskondadel liikuda reaktiivsest tulekustutamisest struktureeritud, pideva parendamise suunas.',
    whyTitle: 'Miks Outsprinter sobib tootmiskeskkondadesse',
    why1: 'Ühendab KPI-d, ülesanded ja projektid ühes süsteemis',
    why2: 'Toetab nii igapäevaseid operatsioone kui pikaajalisi parendusi',
    why3: 'Skaleerub üksikust tehasest mitme asukohaga organisatsioonideni',
    why4: 'Pakub reaalajas nähtavust ilma keerukust lisamata',
    ctaTitle: 'Juhi tootmist selguse ja kontrolliga.',
  },

  // Blog Post UI
  blogPost: {
    home: 'Avaleht',
    backToBlog: 'Tagasi blogisse',
    linkCopied: 'Link kopeeritud!',
    linkCopiedDesc: 'Artikli link on kopeeritud lõikelauale.',
    topicsCovered: 'Teemad:',
    shareArticle: 'Jaga seda artiklit:',
    aboutAuthor: 'Autorist {{name}}',
    authorBio: 'Ettevõtja, äriingel ja Outsprinteri asutaja. Pühendunud skaleeritavate ettevõtete ehitamisele selge täitmise ja mõõdetavate tulemustega.',
    connectLinkedIn: 'Ühenda LinkedInis',
    relatedArticles: 'Seotud artiklid',
    ctaTitle: 'Alusta KPI-de jälgimist õigesti',
    ctaDesc: 'Rakenda need teadmised praktikasse Outsprinteriga. Iganädalane jälgimine, visuaalsed töölauad ja selge vastutus.',
    ctaBtn: 'Loo konto',
    allRights: 'Kõik õigused kaitstud.',
  },

  cookies: {
    message: 'Kasutame küpsiseid ja analüütikat, et parandada teie kasutuskogemust. Nõustudes lubate meil koguda anonüümseid kasutusandmeid Google Analyticsi kaudu.',
    learnMore: 'Loe lähemalt',
    decline: 'Keeldu',
    accept: 'Nõustu',
  },
  strategyAnalyzer: {
    title: 'AI strateegia analüsaator',
    subtitle: 'Laadige üles oma strateegia dokument ja AI soovitab meeskondi ja KPI\'sid',
    uploadFile: 'Laadi fail üles (.txt, .csv, .pdf)',
    chooseFile: 'Vali fail...',
    orPasteText: 'või kleebi tekst',
    textLabel: 'Strateegia dokumendi tekst',
    textPlaceholder: 'Kleepige siia oma ettevõtte strateegia, visioon, eesmärgid või äriplaan...\n\nLisage info organisatsiooni struktuuri, peamiste eesmärkide, sihturgude ja tulemuseesmärkide kohta.',
    charCount: 'tähemärki',
    moreDetailBetter: 'Mida rohkem detaile lisate, seda paremad on soovitused',
    skipStep: 'Jäta see samm vahele',
    analyzeWithAI: 'Analüüsi AI-ga',
    textTooShort: 'Tekst on liiga lühike',
    textTooShortDesc: 'Palun kirjeldage oma ettevõtte strateegiat üksikasjalikumalt (vähemalt paar lõiku).',
    provideText: 'Palun sisestage strateegia tekst',
    analyzingTitle: 'Analüüsime teie strateegiat...',
    analyzingDesc: 'AI loeb teie dokumenti ja valmistab ette meeskondade ja KPI\'de soovitused.\nSee võib võtta 15-30 sekundit.',
    applyingTitle: 'Seadistame teie tööruumi...',
    reviewTitle: 'Vaadake AI soovitused üle',
    reviewSubtitle: 'Klõpsake üksusel, et seda kaasata või välja jätta',
    suggestedTeams: 'Soovitatud meeskonnad',
    suggestedKPIs: 'Soovitatud KPI\'d',
    selectAll: 'Vali kõik',
    deselectAll: 'Tühista valik',
    included: 'Kaasatud',
    excluded: 'Välja jäetud',
    target: 'Sihtmärk:',
    back: 'Tagasi',
    apply: 'Rakenda {{teams}} meeskonda ja {{kpis}} KPI\'d',
    selectAtLeastOneTeam: 'Jätkamiseks valige vähemalt üks meeskond',
    selectOneTeamToast: 'Palun valige vähemalt üks meeskond',
    analysisFailed: 'Analüüs ebaõnnestus',
    tryAgain: 'Palun proovige uuesti.',
    applyError: 'Viga soovituste rakendamisel',
    failedReadPDF: 'PDF-i lugemine ebaõnnestus',
    failedReadPDFDesc: 'PDF-faili ei saanud lugeda. Proovige tekst otse kleepida.',
    unsupportedFile: 'Toetamata failitüüp',
    unsupportedFileDesc: 'Palun laadige üles .txt, .csv või .pdf fail, või kleepige strateegia tekst otse.',
  },
  sprintTasks: {
    tasks: 'Ülesanded',
    loadingTasks: 'Ülesannete laadimine...',
    noTasksTitle: 'Ülesandeid pole',
    noTasksDesc: 'Ülesanded ilmuvad siia, kui need on sprintidesse lisatud.',
    allTasks: 'Kõik ülesanded',
    notStarted: 'Alustamata',
    inProgress: 'Pooleli',
    done: 'Tehtud',
    overdue: 'Üle tähtaja',
    task: 'Ülesanne',
    sprint: 'Sprint',
    responsible: 'Vastutaja',
    status: 'Staatus',
    progress: 'Edenemine',
    dueDate: 'Tähtaeg',
    completed: 'Lõpetatud',
    duration: 'Kestus',
    carriedOver: 'Üle kantud',
    sameDay: 'Samal päeval',
    day: 'päev',
    days: 'päeva',
    daysOverdue: 'p üle tähtaja',
    daysLeft: 'p jäänud',
  },
};

export default et;
